import {ChangeDetectionStrategy, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {parseISO, startOfDay} from 'date-fns';
import {CalendarEvent, CalendarEventTimesChangedEvent, CalendarView, DAYS_OF_WEEK} from 'angular-calendar';
import {Observable, Subject} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {EditRevisionProfileComponent} from '../view/view.component';
import {DatePipe} from '@angular/common';
import {ContextMenuComponent} from 'ngx-contextmenu';
import moment from 'moment';
import {HttpParameterCodec} from '@angular/common/http';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {DialogAddressBookV2Component} from '../../additionalDialog/dialog-address-book-v2/dialog-address-book-v2.component';
import {DialogTableDTOComponent} from '../../additionalDialog/dialogTableDTOComponent';
import {ProgressSpinnerDialogComponent} from '../../additionalDialog/progress-spinner-dialog/progress-spinner-dialog.component';
import {UntypedFormControl} from '@angular/forms';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {BodyFieldToSave} from '../../bodyFieldToSave';
import {DialogMultiDTOComponent} from '../../additionalDialog/dialogMultiDTOComponent';
import {DialogMaskComponent} from '../../additionalDialog/dialogMaskComponents';
import {DialogClassViewDTOComponentDTOComponent} from '../../additionalDialog/dialogClassViewDTOComponent';
import {DialogSearchDocComponent} from '../../additionalDialog/dialogSearchDocComponents';
import {CdkDragDrop} from '@angular/cdk/drag-drop';
import {trigger, transition, style, animate} from '@angular/animations';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-tabella-presenze',
  templateUrl: './gestione-prenotazioni.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./gestione-prenotazioni.component.css'],
  animations: [
    trigger('dragAnimation', [
      transition(':enter', [
        style({opacity: 0, transform: 'scale(0.8)'}),
        animate('300ms cubic-bezier(0.35, 0, 0.25, 1)', style({opacity: 1, transform: 'scale(1)'}))
      ]),
      transition(':leave', [
        animate('300ms cubic-bezier(0.35, 0, 0.25, 1)', style({opacity: 0, transform: 'scale(0.8)'}))
      ])
    ])
  ]
})

export class GestionePrenotazioniComponent implements OnInit {
  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;
  dataRifIndex: number;
  dataEndIndex: number;
  docnProgettoIndex: number;
  dipendenteIndex: number;
  docnumberIndex: number;
  oraInizioIndex: number;
  oreEffettiveIndex: number;
  oreRimasteIndex: number;
  clienteIndex: number;
  isRapportinatoIndex: number;
  ganttIndex: number;
  statoIndex: number;
  attivitaIndex: number;
  descrizioneIndex: string;
  dataLegenda: Array<any> = new Array<any>();
  refresh: Subject<any> = new Subject();
  eventType = '';
  startHour: any;
  endHour: any;
  view: CalendarView = CalendarView.Month;
  bodyGetProgrammazione = {
    id: '66902896817443de8ad44075ddacf6bb',
    searchFilterDto: {
      daAAndOr: 1,
    }
  };
  bodyGetOreRapportinate = {
    id: '87d235286cad4c7e8053a81c4a3940ed',
    searchFilterDto: {
      daAAndOr: 1,
    }
  };
  bodyGetOreRapportinateCteam = {
    id: '957f1270008a448da316ce8bca972c4f',
    searchFilterDto: {
      daAAndOr: 1,
    }
  };
  bodyGetFerie = {
    id: '0f84b1f5290242c39ade2e49e0035a2a', // 0f84b1f5290242c39ade2e49e0035a2a
    searchFilterDto: {
      daAAndOr: 1,
    }
  };
  impegnoTotale = 0;
  clickedDate = '';
  viewDate: Date = startOfDay(new Date());

  locale = 'it';
  // @ts-ignore
  events: CalendarEvent[] = [];
  arrayRapportini: any;
  /*{
        start: startOfDay(new Date()),
        title: 'presenzaFull',
        cssClass: 'presenzaFull',
      },
      {
        start: startOfDay(new Date()),
        title: 'presenzaMattino',
        cssClass: 'presenzaMattino',
      },
      {
        start: startOfDay(new Date()),
        title: 'presenzaPomeriggio',
        cssClass: 'presenzaPomeriggio',
      },
      {
        start: startOfDay(new Date()),
        title: 'smartWorking',
        cssClass: 'smartWorking',
      },
      {
        start: startOfDay(new Date()),
        title: 'offWorking',
        cssClass: 'offWorking',
      }*/

  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;

  weekendDays: number[] = [DAYS_OF_WEEK.FRIDAY, DAYS_OF_WEEK.SATURDAY];
  CalendarView = CalendarView;
  isAteam = false;
  isCteam = false;
  dataSource: any;
  dataSourceFerie: any;
  ferieMittenteIndex: number;
  ferieTipologiaIndex: number;
  ferieDataInizioIndex: number;
  ferieDataFineIndex: number;
  ferieDataPermessoIndex: number;
  ferieOraInizioIndex: number;
  ferieOraFineIndex: number;
  hideFeriePermessiVar = true;
  selectedTecnico = 'BTS\\' + localStorage.getItem('username');
  currentUserConnected = 'BTS\\' + localStorage.getItem('username');
  isDragging = false;
  droppedEvent: any;
  dialogRefSpinner: MatDialogRef<ProgressSpinnerDialogComponent>;
  observable: any;
  constructor(public apiService: ApiService, private datePipe: DatePipe, public dialog: MatDialog, private route: ActivatedRoute,
              private router: Router, private snackBar: MatSnackBar) {
  }

  onDrop(event: CdkDragDrop<Event[]>): void {
    if (this.isDragging) {
      this.droppedEvent = event.item.data;
      this.isDragging = false;
    }

  }

  onDragStarted(event: any): void {
    this.isDragging = true;
  }

  onDragEnded(event: any): void {
    setTimeout(() => {
      this.isDragging = false;
    }, 10);

  }

  mouseup(day: any): void {
    if (this.isDragging) {
      this.isDragging = false;
    }
    setTimeout(() => {
      if (this.droppedEvent) {

        // aggiorna evento .....

        if (this.TransformDataFormatToSave(day.date) === this.TransformDataFormatToSave(this.droppedEvent.start)){ // spostato nello stesso giorno

        }else{
          this.apiService.getProfileSchemaSwitched(this.droppedEvent.docN).subscribe(res => {
            this.events.forEach(eve => {
              if (eve.docN === this.droppedEvent.docN){
                eve.start = day.date;
                eve.end = day.date;
                this.refresh.next();
              }
            });
            res.fields.forEach(f => {
              if (f.name === 'DataDoc') { // Ore previste
                f.value = this.TransformDataFormatToSave(day.date);
              }

            });
            this.updateProfile(res, this.droppedEvent.docN);
          });
        }
        // fine aggiornamento
      }
    }, 50);
  }

  showProgressSpinner(observable: Observable<any>): void {
    this.dialogRefSpinner = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    const subscription = observable.subscribe(
      (response: any) => {
        subscription.unsubscribe();
        // handle response
        // console.log(response);
        this.dialogRefSpinner.close();
      },
      (error) => {
        subscription.unsubscribe();
        // handle error
        this.dialogRefSpinner.close();
      }
    );
  }
  myObservableLoading(observer): void {

  }
  updateProfile(res: any, docN: string): void {
    this.apiService.updateProfile(res, docN).subscribe(profile => {
      this.droppedEvent = null;
    });
  }
  convertHex(hexCode, opacity = 0.1): string {
    let hex = hexCode.replace('#', '');

    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    const r = parseInt(hex.substring(0, 2), 16),
      // tslint:disable-next-line:prefer-const
      g = parseInt(hex.substring(2, 4), 16),
      // tslint:disable-next-line:prefer-const
      b = parseInt(hex.substring(4, 6), 16);

    /* Backward compatibility for whole number based opacity values. */
    if (opacity > 1 && opacity <= 100) {
      opacity = opacity / 100;
    }

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
  }

  stringToColour(text: string): string {
    switch (text) {
      case 'BTS\\michele.biavaschi':
        return '#4CAF50';
      case 'BTS\\omar.pedrotti':
        return '#2196F3';
      case 'BTS\\angelo.gorga':
        return '#9E9E9E';
      case 'BTS\\marco.zocco':
        return '#9F5FFF';
      case 'BTS\\angelo.ciceri':
        return '#a89b00';
      case 'BTS\\alessandro.cazzaniga':
        return '#FF9800';
      case 'BTS\\grazia.tarabini':
        return '#2196F3';
      case 'BTS\\elisabetta.azzetti':
        return '#4CAF50';
      case 'BTS\\veronica.gnocchi':
        return '#9E9E9E';
      case 'BTS\\alessandra.tam':
        return '#9F5FFF';
      default:
        text += 'm';
        let hash = 0;
        // tslint:disable-next-line:no-shadowed-variable
        for (let i = 0; i < text.length; i++) {
          // tslint:disable-next-line:no-bitwise
          hash = text.charCodeAt(i) + ((hash << 5) - hash);
        }
        let colour = '#';
        for (let i = 0; i < 3; i++) {
          // tslint:disable-next-line:no-bitwise
          const value = (hash >> (i * 8)) & 0xFF;
          colour += ('00' + value.toString(16)).substr(-2);
        }
        return colour;
    }

  }

  showTecnico(nomeTecnico: string): void {

    let loadImpegno = false;
    if (this.selectedTecnico === '') {
      this.selectedTecnico = nomeTecnico;
    } else if (this.selectedTecnico !== nomeTecnico) {
      this.selectedTecnico = nomeTecnico;
    } else {
      this.selectedTecnico = '';
      loadImpegno = true;
    }
    if (!loadImpegno) {
      this.impegnoTotale = 0;
      this.events.forEach(e => {
        if (e.tecnico.toLowerCase() === nomeTecnico.toLowerCase() && e.id === 'schedulazione') {

          if (e.hourNumber) {
            if (e.start.getTime() >= this.viewDate.getTime()) {
              this.impegnoTotale += e.hourNumber;
            }

          }

        }
      });
    }
  }

  hideFeriePermessi(): void {
    this.hideFeriePermessiVar = !this.hideFeriePermessiVar;
  }

  cellClicked(event: any): void {
    console.log(event);
    const tempEventsToPass = [];
    this.dataSource.data.forEach(v => {
      const date1 = new Date(startOfDay(parseISO(v[this.dataRifIndex])));
      if (date1.getTime() === event.day.date.getTime()) {
        tempEventsToPass.push({
          data: event.day.date,
          dipendente: v[this.dipendenteIndex],
          tipologia: v[this.docnProgettoIndex],
          inizio: v[this.oraInizioIndex]
        });
      }
    });
    const dialogRef = this.dialog.open(ShowPrenotazioniEventComponent, {
      width: '37%',
      data: {
        events: event.day.events,
        day: event.day,
        docN: event.docn,
        selectedUser: this.selectedTecnico,
        isAteam: this.isAteam,
        isCteam: this.isCteam
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.reloadCalendar();
      this.loadOreRapportinate();
    });
  }

  TransformDataFormatToShow(Data: string): string {

    return this.datePipe.transform(Data, 'dd/MM/yyyy', '', 'en-GB');
  }


  reloadCalendar(): void {
    this.apiService.getViewFilter(this.bodyGetProgrammazione).subscribe(result => {
      this.events = new Array<any>();
      this.dataSource = result;
      result.columns.forEach((v, index) => {
        if (v.id === 'DATADOC') {
          this.dataRifIndex = index;
        } else if (v.id === 'DESTINATARIO') {
          this.clienteIndex = index;
        } else if (v.id === 'DATADOC') {
          this.dataEndIndex = index;
        } else if (v.id === 'MITTENTE') {
          this.dipendenteIndex = index;
        } else if (v.id === 'COMBO681_154') {
          this.docnProgettoIndex = index;
        } else if (v.id === 'DOCNUMBER') {
          this.docnumberIndex = index;
        } else if (v.id === 'NUMERIC678_154') { // ore previste
          this.oraInizioIndex = index;
        } else if (v.id === 'STATO') {
          this.statoIndex = index;
        } else if (v.id === 'CHECK537_91') {
          this.ganttIndex = index;
        } else if (v.id === 'TESTO680_154') {
          this.attivitaIndex = index;
        } else if (v.id === 'NUMERIC679_154') { // ore effettive
          this.oreEffettiveIndex = index;
        } else if (v.id === 'TESTO677_154') { // ore residue
          this.oreRimasteIndex = index;
        } else if (v.id === 'TESTO12_12') { // descrizione rapp
          this.descrizioneIndex = index;
        } else if (v.id === 'CHECK682_154') { // descrizione rapp
          this.isRapportinatoIndex = index;
        }
      });
      this.dataLegenda = new Array<any>();
      result.data.forEach(v => {
        let addEvent = false;
        if (this.isAteam) {
          if (v[this.dipendenteIndex] !== 'BTS\\veronica.gnocchi' && v[this.dipendenteIndex] !== 'BTS\\grazia.tarabini' && v[this.dipendenteIndex] !== 'BTS\\elisabetta.azzetti' && v[this.dipendenteIndex] !== 'BTS\\alessandra.tam') {
            addEvent = true;
          }
        } else if (this.isCteam) {
          if (v[this.dipendenteIndex] === 'BTS\\veronica.gnocchi' || v[this.dipendenteIndex] === 'BTS\\grazia.tarabini' || v[this.dipendenteIndex] === 'BTS\\elisabetta.azzetti' || v[this.dipendenteIndex] === 'BTS\\alessandra.tam') {
            addEvent = true;
          }
        }
        let found = false;
        this.dataLegenda.forEach(res => {
          if (res.nome === v[this.dipendenteIndex]) {
            found = true;
          }
        });

        if (!found && addEvent) {
          this.dataLegenda.push({nome: v[this.dipendenteIndex], colore: this.stringToColour(v[this.dipendenteIndex])});
        }
        switch (v[this.docnProgettoIndex]) {
          case 'Auto fiat 500 5 posti':
            this.events.push({
                start: startOfDay(parseISO(v[this.dataRifIndex])),
                title: v[this.docnProgettoIndex],
                cssClass: 'presenzaFull',
              }
            );
            break;
          default:
            let found = false;
            this.events.forEach(e => {
              if (e.title === v[this.clienteIndex] + ': ' + v[this.attivitaIndex] && e.tecnico === v[this.dipendenteIndex] && e.docN === v[this.docnumberIndex]) {
                found = true;
                if (v[this.ganttIndex] === 1 && v[this.statoIndex] !== 'Chiuso') {
                  if (e.start > startOfDay(parseISO(v[this.dataRifIndex]))) {
                    e.start = startOfDay(parseISO(v[this.dataRifIndex]));
                  }
                  if (e.end < startOfDay(parseISO(v[this.dataEndIndex]))) {
                    e.end = startOfDay(parseISO(v[this.dataEndIndex]));
                  }
                  e.hourNumber += Number(v[this.oraInizioIndex].replace(/\D/g, ''));
                  e.checkList.push({
                    dipendente: v[this.dipendenteIndex], docN: v[this.docnumberIndex], oggetto: v[this.attivitaIndex],
                    dataInizio: v[this.dataRifIndex], dataFine: v[this.dataEndIndex], tempo: v[this.oraInizioIndex]
                  });
                }

              }
            });
            if (!found) {

              if (addEvent) { // aggiunge l'evento solo se l'utente loggato fa parte del giusto team
                this.events.push({
                    id: 'schedulazione',
                    progettoDocN: v[this.docnProgettoIndex],
                    start: startOfDay(parseISO(v[this.dataRifIndex])),
                    end: startOfDay(parseISO(v[this.dataRifIndex])),
                    title: v[this.clienteIndex] + ': ' + v[this.attivitaIndex],
                    hourNumber: v[this.oraInizioIndex],
                    oreEffettive: v[this.oreEffettiveIndex],
                    oreRimaste: v[this.oreRimasteIndex],
                    attivita: v[this.attivitaIndex],
                    color: {
                      primary: this.stringToColour(v[this.dipendenteIndex]),
                      secondary: this.convertHex(this.stringToColour(v[this.dipendenteIndex]))
                    },
                    isRapportinato: v[this.isRapportinatoIndex],
                    descrizione: v[this.descrizioneIndex],
                    extraColor: this.stringToColour(v[this.dipendenteIndex]),
                    cssClass: 'smartWorking',
                    docN: v[this.docnumberIndex],
                    checkList: [{
                      dipendente: v[this.dipendenteIndex], docN: v[this.docnumberIndex], oggetto: v[this.attivitaIndex],
                      dataInizio: v[this.dataRifIndex], dataFine: v[this.dataEndIndex], tempo: v[this.oraInizioIndex]
                    }],
                    tecnico: v[this.dipendenteIndex],
                  }
                );
              }
            }

        }
      });
      this.impegnoTotale = 0;
      this.events.forEach(e => {
        if (e.tecnico.toLowerCase() === this.selectedTecnico.toLowerCase() && e.id === 'schedulazione') {

          if (e.hourNumber) {
            if (e.start.getTime() >= this.viewDate.getTime()) {
              this.impegnoTotale += e.hourNumber;
            }

          }

        }
      });
      this.refresh.next();
      this.events.sort((a, b) => {
        if (a.tecnico < b.tecnico) {
          return -1;
        }
        if (a.tecnico > b.tecnico) {
          return 1;
        }
        return 0;
      });
    });


  }


  eventClick(event: any): void {


    const dialogRef = this.dialog.open(ShowPrenotazioniEventComponent, {
      width: '37%',
      data: {
        events: event.sourceEvent.events,
        day: event.sourceEvent,
        oreImpegno: event.event.hourNumber,
        selectedUser: this.selectedTecnico, isAteam: this.isAteam, isCteam: this.isCteam
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.reloadCalendar();
      this.loadOreRapportinate();
    });
  }

  startHourChanged(event: any): void {
    this.startHour = event;
  }

  endHourChanged(event: any): void {
    this.endHour = event;
  }

  setEventType(event: string): void {

    this.eventType = event;
  }

  resetVariables(): void {
    console.log(this.startHour);
    console.log(this.endHour);

    this.eventType = '';
    this.startHour = '';
    this.endHour = '';
  }

  isCompreso(startHourToCheck: string, endHourToCheck: string, startHour: string, endHour: string): void {

  }

  getNumInterventi(events: any): number {
    let contatore = 0;
    events.forEach(e => {
      if (e.id === 'schedulazione') {
        contatore++;
      }
    });
    return contatore;
  }

  loadOreRapportinateTot(date: any): number {
    if (this.arrayRapportini) {
      if (this.arrayRapportini[date]) {
        let sum = 0;
        this.arrayRapportini[date].forEach(a => {//a.MITTENTE.replace(/\\/, '\\')
          if ((a.MITTENTE.replace(/\\/, '\\') === this.selectedTecnico || this.selectedTecnico === '')) {
            sum += a.NUMERIC5_12;
          }
        });
        return sum;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  loadOrePrevisteTot(dayEvents: any): number {

    let tempPreviste = 0;
    dayEvents.forEach(eve => {
      if (eve.tecnico === this.selectedTecnico || this.selectedTecnico === '') {
        tempPreviste += eve.hourNumber;
      }
    });
    return tempPreviste;
  }

  loadOreEffettiveTot(dayEvents: any): number {
    let tempEffettive = 0;
    dayEvents.forEach(eve => {
      if (eve.tecnico === this.selectedTecnico || this.selectedTecnico === '') {
        tempEffettive += eve.oreEffettive;
      }
    });
    return tempEffettive;
  }

  addEvent(event: any): void {
    console.log(event);
    const tempEvents = [];
    this.dataSource.data.forEach(v => {
      const date1 = new Date(startOfDay(parseISO(v[this.dataRifIndex])));
      if (date1.getTime() === event.item.getTime()) {
        tempEvents.push({
          data: event.item,
          dipendente: v[this.dipendenteIndex],
          tipologia: v[this.docnProgettoIndex],
          inizio: v[this.oraInizioIndex]
        });
      }
    });
    console.log(tempEvents);
    tempEvents.forEach(te => {
      let isOk = true;
      if (te.tipologia === this.eventType) {
        if (this.startHour >= te.inizio && this.startHour <= te.fine) {
          if (this.startHour === te.fine) {

          } else {
            isOk = false;
          }
        } else {

        }
        if (this.startHour <= te.inizio && this.endHour > te.inizio) {
          isOk = false;
        } else {

        }


        if (!isOk) {
          this.snackBar.open('Il veicolo selezionato: ' + this.eventType + ' non è disponibile nel periodo di tempo scelto', null, {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'bottom',
            panelClass: ['mat-toolbar', 'custom-danger-bg']
          });
        } else {
          if (this.eventType !== '') {
            const json = {
              fields: [
                {
                  value: this.TransformDataFormatToSave(event.item),
                  additionalFieldType: 1,
                  groupId: 0,
                  binderFieldId: 0,
                  taskWorkVariableId: 0,
                  validationType: 0,
                  validationString: '',
                  name: 'DATA690_193',
                  externalId: '',
                  description: 'Data di riferimento',
                  order: 0,
                  dataSource: null,
                  required: false,
                  formula: '',
                  className: 'AdditionalFieldDateTimeDTO',
                  locked: false,
                  comboGruppiId: null,
                  dependencyFields: [],
                  associations: [],
                  isAdditional: true,
                  visible: true,
                  predefinedProfileFormula: null,
                  visibilityCondition: '',
                  mandatoryCondition: '',
                  addressBookDefaultFilter: null,
                  enabledAddressBook: [],
                  columns: null,
                  focus: true
                },
                {
                  limitToList: false,
                  displayValue: null,
                  value: this.eventType,
                  numMaxChar: 500,
                  numRows: 0,
                  additionalFieldType: 3,
                  groupId: 0,
                  binderFieldId: 0,
                  taskWorkVariableId: 0,
                  validationType: 0,
                  validationString: '',
                  name: 'COMBO737_204',
                  externalId: '',
                  description: 'Tipologia',
                  order: 1,
                  dataSource: null,
                  required: false,
                  formula: '',
                  className: 'AdditionalFieldComboDTO',
                  locked: false,
                  comboGruppiId: null,
                  dependencyFields: [],
                  associations: [],
                  isAdditional: true,
                  visible: true,
                  predefinedProfileFormula: null,
                  visibilityCondition: '',
                  mandatoryCondition: '',
                  addressBookDefaultFilter: null,
                  enabledAddressBook: [],
                  columns: null
                },
                {
                  limitToList: true,
                  displayValue: null,
                  value: localStorage.getItem('username'),
                  numMaxChar: 100,
                  numRows: 0,
                  additionalFieldType: 3,
                  groupId: 0,
                  binderFieldId: 0,
                  taskWorkVariableId: 0,
                  validationType: 0,
                  validationString: '',
                  name: 'COMBO691_193',
                  externalId: '',
                  description: 'Dipendente',
                  order: 1,
                  dataSource: null,
                  required: false,
                  formula: '',
                  className: 'AdditionalFieldComboDTO',
                  locked: false,
                  comboGruppiId: null,
                  dependencyFields: [],
                  associations: [],
                  isAdditional: true,
                  visible: true,
                  predefinedProfileFormula: null,
                  visibilityCondition: '',
                  mandatoryCondition: '',
                  addressBookDefaultFilter: null,
                  enabledAddressBook: [],
                  columns: null
                },
                {
                  displayValue: null,
                  value: this.startHour,
                  numMaxChar: 100,
                  numRows: 1,
                  additionalFieldType: 0,
                  groupId: 0,
                  binderFieldId: 0,
                  taskWorkVariableId: 0,
                  validationType: 0,
                  validationString: '',
                  name: 'TESTO740_204',
                  externalId: '',
                  description: 'Ora inizio',
                  order: 3,
                  dataSource: null,
                  required: false,
                  formula: '',
                  className: 'AdditionalFieldStringDTO',
                  locked: false,
                  comboGruppiId: null,
                  dependencyFields: [],
                  associations: [],
                  isAdditional: true,
                  visible: true,
                  predefinedProfileFormula: null,
                  visibilityCondition: '',
                  mandatoryCondition: '',
                  addressBookDefaultFilter: null,
                  enabledAddressBook: [],
                  columns: null
                },
                {
                  displayValue: null,
                  value: this.endHour,
                  numMaxChar: 100,
                  numRows: 1,
                  additionalFieldType: 0,
                  groupId: 0,
                  binderFieldId: 0,
                  taskWorkVariableId: 0,
                  validationType: 0,
                  validationString: '',
                  name: 'TESTO741_204',
                  externalId: '',
                  description: 'Ora fine',
                  order: 4,
                  dataSource: null,
                  required: false,
                  formula: '',
                  className: 'AdditionalFieldStringDTO',
                  locked: false,
                  comboGruppiId: null,
                  dependencyFields: [],
                  associations: [],
                  isAdditional: true,
                  visible: true,
                  predefinedProfileFormula: null,
                  visibilityCondition: '',
                  mandatoryCondition: '',
                  addressBookDefaultFilter: null,
                  enabledAddressBook: [],
                  columns: null
                }
              ]
            };
            let found = false;
            if (this.dataSource) {
              if (true) {


                this.dataSource.data.forEach(v => {
                  const date1 = new Date(startOfDay(parseISO(v[this.dataRifIndex])));
                  if (date1.getTime() === event.item.getTime() && localStorage.getItem('username') === v[this.dipendenteIndex]) {
                    found = true;
                    this.apiService.deleteProfile(v[this.docnumberIndex]).subscribe(res => {
                      this.apiService.insertNewProfile(json, 'da313e3116ea427a885add2e2e818340').subscribe(res => {
                        this.snackBar.open('Evento aggiunto correttamente', null, {
                          duration: 4000,
                          horizontalPosition: 'end',
                          verticalPosition: 'bottom',
                          panelClass: ['mat-toolbar', 'custom-success-bg']
                        });
                        this.reloadCalendar();

                      }, errorLog => {
                        this.snackBar.open(errorLog.error.userMessage, null, {
                          duration: 4000,
                          horizontalPosition: 'end',
                          verticalPosition: 'bottom',
                          panelClass: ['mat-toolbar', 'custom-danger-bg']
                        });
                      });
                    }, errorLog => {
                      this.snackBar.open(errorLog.error.userMessage, null, {
                        duration: 4000,
                        horizontalPosition: 'end',
                        verticalPosition: 'bottom',
                        panelClass: ['mat-toolbar', 'custom-danger-bg']
                      });
                    });
                  }
                });
              }
            }
            if (!found) {
              this.apiService.insertNewProfile(json, 'da313e3116ea427a885add2e2e818340').subscribe(res => {
                this.snackBar.open('Evento aggiunto correttamente', null, {
                  duration: 4000,
                  horizontalPosition: 'end',
                  verticalPosition: 'bottom',
                  panelClass: ['mat-toolbar', 'custom-success-bg']
                });
                this.reloadCalendar();

              }, errorLog => {
                this.snackBar.open(errorLog.error.userMessage, null, {
                  duration: 4000,
                  horizontalPosition: 'end',
                  verticalPosition: 'bottom',
                  panelClass: ['mat-toolbar', 'custom-danger-bg']
                });
              });

            }
          }
        }
      }
    });
    if (tempEvents.length === 0) {
      if (this.eventType !== '') {
        const json = {
          fields: [
            {
              value: this.TransformDataFormatToSave(event.item),
              additionalFieldType: 1,
              groupId: 0,
              binderFieldId: 0,
              taskWorkVariableId: 0,
              validationType: 0,
              validationString: '',
              name: 'DATA690_193',
              externalId: '',
              description: 'Data di riferimento',
              order: 0,
              dataSource: null,
              required: false,
              formula: '',
              className: 'AdditionalFieldDateTimeDTO',
              locked: false,
              comboGruppiId: null,
              dependencyFields: [],
              associations: [],
              isAdditional: true,
              visible: true,
              predefinedProfileFormula: null,
              visibilityCondition: '',
              mandatoryCondition: '',
              addressBookDefaultFilter: null,
              enabledAddressBook: [],
              columns: null,
              focus: true
            },
            {
              limitToList: false,
              displayValue: null,
              value: this.eventType,
              numMaxChar: 500,
              numRows: 0,
              additionalFieldType: 3,
              groupId: 0,
              binderFieldId: 0,
              taskWorkVariableId: 0,
              validationType: 0,
              validationString: '',
              name: 'COMBO737_204',
              externalId: '',
              description: 'Tipologia',
              order: 1,
              dataSource: null,
              required: false,
              formula: '',
              className: 'AdditionalFieldComboDTO',
              locked: false,
              comboGruppiId: null,
              dependencyFields: [],
              associations: [],
              isAdditional: true,
              visible: true,
              predefinedProfileFormula: null,
              visibilityCondition: '',
              mandatoryCondition: '',
              addressBookDefaultFilter: null,
              enabledAddressBook: [],
              columns: null
            },
            {
              limitToList: true,
              displayValue: null,
              value: localStorage.getItem('username'),
              numMaxChar: 100,
              numRows: 0,
              additionalFieldType: 3,
              groupId: 0,
              binderFieldId: 0,
              taskWorkVariableId: 0,
              validationType: 0,
              validationString: '',
              name: 'COMBO691_193',
              externalId: '',
              description: 'Dipendente',
              order: 1,
              dataSource: null,
              required: false,
              formula: '',
              className: 'AdditionalFieldComboDTO',
              locked: false,
              comboGruppiId: null,
              dependencyFields: [],
              associations: [],
              isAdditional: true,
              visible: true,
              predefinedProfileFormula: null,
              visibilityCondition: '',
              mandatoryCondition: '',
              addressBookDefaultFilter: null,
              enabledAddressBook: [],
              columns: null
            },
            {
              displayValue: null,
              value: this.startHour,
              numMaxChar: 100,
              numRows: 1,
              additionalFieldType: 0,
              groupId: 0,
              binderFieldId: 0,
              taskWorkVariableId: 0,
              validationType: 0,
              validationString: '',
              name: 'TESTO740_204',
              externalId: '',
              description: 'Ora inizio',
              order: 3,
              dataSource: null,
              required: false,
              formula: '',
              className: 'AdditionalFieldStringDTO',
              locked: false,
              comboGruppiId: null,
              dependencyFields: [],
              associations: [],
              isAdditional: true,
              visible: true,
              predefinedProfileFormula: null,
              visibilityCondition: '',
              mandatoryCondition: '',
              addressBookDefaultFilter: null,
              enabledAddressBook: [],
              columns: null
            },
            {
              displayValue: null,
              value: this.endHour,
              numMaxChar: 100,
              numRows: 1,
              additionalFieldType: 0,
              groupId: 0,
              binderFieldId: 0,
              taskWorkVariableId: 0,
              validationType: 0,
              validationString: '',
              name: 'TESTO741_204',
              externalId: '',
              description: 'Ora fine',
              order: 4,
              dataSource: null,
              required: false,
              formula: '',
              className: 'AdditionalFieldStringDTO',
              locked: false,
              comboGruppiId: null,
              dependencyFields: [],
              associations: [],
              isAdditional: true,
              visible: true,
              predefinedProfileFormula: null,
              visibilityCondition: '',
              mandatoryCondition: '',
              addressBookDefaultFilter: null,
              enabledAddressBook: [],
              columns: null
            }
          ]
        };
        let found = false;
        if (this.dataSource) {
          if (true) {


            this.dataSource.data.forEach(v => {
              const date1 = new Date(startOfDay(parseISO(v[this.dataRifIndex])));
              if (date1.getTime() === event.item.getTime() && localStorage.getItem('username') === v[this.dipendenteIndex]) {
                found = true;
                this.apiService.deleteProfile(v[this.docnumberIndex]).subscribe(res => {
                  this.apiService.insertNewProfile(json, 'da313e3116ea427a885add2e2e818340').subscribe(res => {
                    this.snackBar.open('Evento aggiunto correttamente', null, {
                      duration: 4000,
                      horizontalPosition: 'end',
                      verticalPosition: 'bottom',
                      panelClass: ['mat-toolbar', 'custom-success-bg']
                    });
                    this.reloadCalendar();

                  }, errorLog => {
                    this.snackBar.open(errorLog.error.userMessage, null, {
                      duration: 4000,
                      horizontalPosition: 'end',
                      verticalPosition: 'bottom',
                      panelClass: ['mat-toolbar', 'custom-danger-bg']
                    });
                  });
                }, errorLog => {
                  this.snackBar.open(errorLog.error.userMessage, null, {
                    duration: 4000,
                    horizontalPosition: 'end',
                    verticalPosition: 'bottom',
                    panelClass: ['mat-toolbar', 'custom-danger-bg']
                  });
                });
              }
            });
          }
        }
        if (!found) {
          this.apiService.insertNewProfile(json, 'da313e3116ea427a885add2e2e818340').subscribe(res => {
            this.snackBar.open('Evento aggiunto correttamente', null, {
              duration: 4000,
              horizontalPosition: 'end',
              verticalPosition: 'bottom',
              panelClass: ['mat-toolbar', 'custom-success-bg']
            });
            this.reloadCalendar();

          }, errorLog => {
            this.snackBar.open(errorLog.error.userMessage, null, {
              duration: 4000,
              horizontalPosition: 'end',
              verticalPosition: 'bottom',
              panelClass: ['mat-toolbar', 'custom-danger-bg']
            });
          });

        }
      }
    }


  }

  addIntervent(): void {
    this.router.navigate(['../maskDetails', {
      id: '812976cf45904b6590d072288f538379', idTask: 0,
      path: 'calendario', data: this.TransformDataFormatToSave(this.clickedDate)
    }], {relativeTo: this.route});
  }

  setDayOpened(event: any): void {
    this.clickedDate = event.item;
  }

  removeEvent(event: any): void {
    console.log(this.dataSource);
    let found = false;
    this.dataSource.data.forEach(v => {
      const date1 = new Date(startOfDay(parseISO(v[this.dataRifIndex])));
      if (date1.getTime() === event.getTime() && localStorage.getItem('username') === v[this.dipendenteIndex]) {
        found = true;
        this.apiService.deleteProfile(v[this.docnumberIndex]).subscribe(res => {
          this.snackBar.open('Evento eliminato con successo', null, {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'bottom',
            panelClass: ['mat-toolbar', 'custom-success-bg']
          });
          this.reloadCalendar();
        }, errorLog => {
          this.snackBar.open(errorLog.error.userMessage, null, {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'bottom',
            panelClass: ['mat-toolbar', 'custom-danger-bg']
          });
        });
      }
    });
    if (!found) {
      this.snackBar.open('Nessun evento da eliminare', null, {
        duration: 4000,
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['mat-toolbar', 'custom-warning-bg']
      });

    }
    this.refresh.next();
  }

  isEventSetForUser(date: Date): boolean {
    let found = false;
    if (this.dataSource) {
      this.dataSource.data.forEach(v => {
        const date1 = new Date(startOfDay(parseISO(v[this.dataRifIndex])));
        if (date1.getTime() === date.getTime() && localStorage.getItem('username') === v[this.dipendenteIndex]) {
          found = true;
        }
      });
    }

    if (found) {
      return true;
    } else {
      return false;
    }
  }

  getEventType(date: Date): string {
    let found = false;
    let tipologia = '';
    if (this.dataSource) {
      this.dataSource.data.forEach(v => {
        const date1 = new Date(startOfDay(parseISO(v[this.dataRifIndex])));
        if (date1.getTime() === date.getTime() && localStorage.getItem('username') === v[this.dipendenteIndex]) {
          found = true;
          tipologia = v[this.docnProgettoIndex];

        }
      });
    }
    if (!found) {
      return '';
    } else {
      return tipologia;
    }

  }

  TransformDataFormatToSave(Data: string): string {

    if (Data === '' || !Data) {
      return '0001-01-01T00:00:00';
    }
    // // console.log(Data);
    const dateMomentObject = moment(Data, 'DD/MM/YYYY'); // 1st argument - string, 2nd argument - format
    const dateObject = dateMomentObject.toDate();
    // // console.log(dateMomentObject);
    if (dateMomentObject.isValid()) {
      return this.datePipe.transform(dateObject, 'yyyy-MM-dd', '', 'en-GB');
    } else {
      return this.datePipe.transform(Data, 'yyyy-MM-dd', '', 'en-GB');
    }

  }

  loadOreRapportinate(): void {
    this.apiService.getViewFilter(this.bodyGetOreRapportinate).subscribe(result => {
      const newArray = result.data.map((row) => {
        const obj = {};
        result.columns.forEach((column, index) => {
          const id = column.id;
          obj[id] = row[index];
        });
        return obj;
      });
      const indexedArray = {};

      for (let i = 0; i < newArray.length; i++) {
        const row = newArray[i];
        const data1 = row.DATA1_12.split('T')[0]; // Extracting date part

        if (!indexedArray[data1]) {
          indexedArray[data1] = [];
        }

        indexedArray[data1].push(row);
      }
      this.arrayRapportini = indexedArray;
    });
  }

  ngOnInit(): void {

    switch (this.currentUserConnected) {
      case 'BTS\\michele.biavaschi':
        this.isAteam = true;
        break;
      case 'BTS\\omar.pedrotti':
        this.isAteam = true;
        break;
      case 'BTS\\angelo.gorga':
        this.isAteam = true;
        break;
      case 'BTS\\marco.zocco':
        this.isAteam = true;
        break;
      case 'BTS\\angelo.ciceri':
        this.isAteam = true;
        break;
      case 'BTS\\alessandro.cazzaniga':
        this.isAteam = true;
        break;
      case 'BTS\\grazia.tarabini':
        this.isCteam = true;
        break;
      case 'BTS\\elisabetta.azzetti':
        this.isCteam = true;
        break;
      case 'BTS\\veronica.gnocchi':
        this.isCteam = true;
        break;
      case 'BTS\\alessandra.tam':
        this.isCteam = true;
        break;
      default:
        this.isAteam = true;
        break;
    }
    if (this.isCteam) {
      this.bodyGetOreRapportinate = this.bodyGetOreRapportinateCteam;
    }
    this.reloadCalendar();
    this.loadOreRapportinate();

    // @ts-ignore
    /* const calendar = document.getElementById('calendario')
     console.log(calendar);*/
  }

  dayClicked({date, events}: { date: Date; events: CalendarEvent[] }): void {
    console.log(date);
    // let x=this.adminService.dateFormat(date)
    // this.openAppointmentList(x)
  }
}

@Component({
  selector: 'app-showprenotazionieventdialog',
  templateUrl: 'showPrenotazioniEventDialog.html',
  styleUrls: ['./gestione-prenotazioni.component.css']
})
export class ShowPrenotazioniEventComponent {
  events: Array<any> = new Array<any>();
  newActivityDescription: string;
  eventDay: any;
  title: string;
  typingTimeout: any;
  oreImpegnate = 0;
  nomeProgetto: string;
  selectedDay: any;
  isAddNew = true;
  dataMaskToSaveProg: any;
  mapAddressBookToSee: Map<string, any> = new Map<string, any>();
  fieldName: string;
  idContact: string;
  toFieldData: any = new Array<any>();
  toCtrl: string;
  mapAddressBookSave: Array<any> = new Array<any>();
  addressBookSelectedToShow: any;
  addressBookSelected: Map<string, string[]> = new Map<string, string[]>();
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  enableAddressBook: number;
  enableAddressBookFrom: number;
  fieldDataSource: Array<any> = [];
  tableValuteDTOSelected: Map<string, string[]> = new Map<string, string[]>();
  keyField = '';
  attivitaValue = '';
  oreRimasteAttivita: number;
  comboAssociationField: any = {};
  tempCombo: Array<any> = new Array<any>();
  selectToAdd = '';
  keyToAdd = '';
  comboValues: any = {};
  comboControl: any = new Array<any>();
  ore = {
    NUMERIC678_154: 0,
    NUMERIC679_154: 0
  };
  oreResidue: number;
  fullComboValues: any;
  selectedUser = '';
  tempBodySetRapportinato: any;
  currentEventAddMask: any;

  // CAMPI MASKDETAILS
  id = 'e7efc139899040c7a24d311c774eae6e';
  idCteam = '89194533c266425b82e3bb1fc2164c7d';
  idTask = '0';
  operationId = this.activatedRoute.snapshot.paramMap.get('operationId');
  goBackTask = this.activatedRoute.snapshot.paramMap.get('goBackTask');
  path = this.activatedRoute.snapshot.paramMap.get('path');
  firstnodepath = this.activatedRoute.snapshot.paramMap.get('firstnodepath');
  dashColor: string;
  backColor: string;
  squareColor: string;
  cardColor: string;
  isOpen = false;
  maskName: string;
  splitMaskName: string;
  splitMaskOrder: string;
  splitMaskCat: string;
  classProfileType: string;
  classProfileName: string;
  classProfileValue: string;
  fields: Array<any> = new Array<any>();
  nomiAoo: Array<any> = new Array<any>();
  originsFields: Array<any> = new Array<any>();
  documenTypes: Array<any> = new Array<any>();
  stateFields: Array<any> = new Array<any>();
  toFields: Array<any> = new Array<any>();
  FromFields: Array<any> = new Array<any>();
  Row: [];

  breakpoint: number;

  multiValuteDTOSelected: Map<string, string[]> = new Map<string, string[]>();

  comboValuteDTOSelected: Map<string, string[]> = new Map<string, string[]>();

  mapMultiValueToSave: Map<string, object[]> = new Map<string, object[]>();
  mapTableValueToSave: any;
  sub: any;
  tableAssociationField: object = {};

  mapTableValueToSee: Map<string, string> = new Map<string, string>();

  mapClasseBookToSave: Map<string, Array<string>> = new Map<string, Array<string>>();
  docType: string;
  // CLASSE BOX
  ELEMENT_DATA_CLASS: Array<object> = new Array<object>();
  arrayToObjectClass: { [index: string]: { content: string } } = {};
  dataSourceClass: MatTableDataSource<object>;
  displayedColumnsClass: Array<string> = new Array<string>();
  docNumberClasseboxTemp: Array<string> = new Array<string>();
  optionsMask: any = {};
  dataMaskToSave: any = {};
  dataValueAssociations: any = {};
  validationCheck: boolean;
  jsonToSendArxivar: any = {};
  fileListMain: FileList;
  fileMain: File;
  todayDate = new Date();
  twDocumentOperationId: string;
  formDataMain: FormData;
  bufferIdInfo: Array<any> = new Array<any>();
  fileInfo: any = {name: '', buffer: ''};
  badgeBufferMain: number;
  arrayToObject: { [index: string]: { content: string } } = {};
  canProfile = true;
  whatToShow = 'default';
  notes: Array<any> = new Array<any>();
  addNoteText = '';
  // chip list
  mapMultiValueToSee: Map<string, any> = new Map<string, any>();
  multiValuteDTOSelectedToShow: Array<any> = new Array<any>();
  visible = true;
  selectable = true;
  addOnBlur = true;
  savedProfileId: string;
  // attachments section
  countFields: number;
  bufferIdInfo2: Array<any> = new Array<any>();
  observable: any;
  progressSpinnerValue = 0;
  loading = false;
  dialogRefSpinner: MatDialogRef<ProgressSpinnerDialogComponent>;
  editCombo: Array<any> = new Array<any>();
  myControl = new UntypedFormControl();
  tempSkipProfileValue: string;
  fromCtrl: string;
  ccCtrl: string;
  fromFieldData: any = new Array<any>();
  ccFieldData: any = new Array<any>();
  savedDocN: string;
  isNewRapportino = false;
  isAteam = false;
  isCteam = false;


  @ViewChild('toField') toField: ElementRef<HTMLInputElement>;
  @ViewChild('fromField') fromField: ElementRef<HTMLInputElement>;
  @ViewChild('ccField') ccField: ElementRef<HTMLInputElement>;

  constructor(public dialog: MatDialog, private snackBar: MatSnackBar, public dialogRef: MatDialogRef<ShowPrenotazioniEventComponent>, private datePipe: DatePipe,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public apiService: ApiService, private route: ActivatedRoute, private router: Router, iconRegistry: MatIconRegistry,
              sanitizer: DomSanitizer,
              private activatedRoute: ActivatedRoute,
              private bodyFieldToSave: BodyFieldToSave) {
    this.isAteam = data.isAteam;
    this.isCteam = data.isCteam;
    this.events = data.events;
    this.title = data.attivita;
    this.selectedDay = data.day.date;
    this.nomeProgetto = data.progetto;
    this.selectedUser = data.selectedUser;
    this.apiService.getProfileSchema('6de03aed607a4739bb6e0b82cc14676a').subscribe(res => {
      this.dataMaskToSaveProg = res;
      this.dataMaskToSaveProg.fields.forEach(v => {
        if (v.name === 'DataDoc') {
          v.value = this.TransformDataFormatToSave(this.selectedDay);
        }
      });
    });

    this.events.forEach(v => {

      switch (v.tipologia) {
        default:
          v.color = '#b8c1df';
      }
    });
    this.eventDay = data.day;
  }

  changedOre(field: any): void {
    this.dataMaskToSaveProg.fields.forEach(v => {
      if (v.name === field.name) {
        v.value = this.ore[v.name];
      }
    });
  }


  checkAutocompleteToActivity(field: any): void {
    if (field.name === 'To') {
      if (this.toCtrl.length > 2) {
        this.apiService.SearchAddressBookFilter(this.toCtrl, field.addressBookDefaultFilter).subscribe(res => {
          // console.log(res);
          this.toFieldData = res;
        });
      } else {
        this.toFieldData = new Array<any>();
      }
    }
  }

  updateDescription(): void {
    this.dataMaskToSaveProg.fields.forEach(field => {
      if (field.name === 'TESTO12_12') {
        field.value = this.newActivityDescription;
      }
    });
  }

  addNewActivity(): void {
    this.apiService.insertNewProfile(this.dataMaskToSaveProg, '6de03aed607a4739bb6e0b82cc14676a').subscribe(results => {
      if (results.showMessage) {

        let descrizione;
        let tecnico_var;
        this.dataMaskToSaveProg.fields.forEach(v => {
          if (v.name === 'TESTO680_154') {
            descrizione = v.value;
          }
          if (v.name === 'From') {
            tecnico_var = v.value.description;
          }
        });

        this.events.push({
          tecnico: tecnico_var,
          attivita: descrizione,
          descrizione: this.newActivityDescription,
          hourNumber: this.ore['NUMERIC678_154'],
          oreEffettive: this.ore['NUMERIC679_154'],
          progettoDocN: this.comboControl['COMBO681_154'].keyField,
          title: this.mapAddressBookToSee.get('To')[0].name + ': ' + descrizione,
          docN: results.docNumber
        });
        this.isAddNew = false;
        this.newProgrammazione();

      } else {

        this.snackBar.open('Errore nel caricamento del profilo', null, {
          duration: 5000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
          panelClass: ['mat-toolbar', 'custom-danger-bg']
        });
      }
    }, errorLog => {

      this.dialogRef.close();
      this.snackBar.open(errorLog.error.userMessage, null, {
        duration: 7000,
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['mat-toolbar', 'custom-danger-bg']
      });
    });
  }

  displayFnActivity(field: any, value?: any): any {
    if (value) {
      if (value.keyField) {
        this.dataMaskToSaveProg.fields.forEach(f => {
          if (f.name === field.name) {
            f.value = value.keyField;
            this.checkComboAssociationsActivity(field, value.keyField);
          }
          if (f.name === 'TESTO680_154') {
            f.value = value.selectField;
          }
        });

        field.value = value.keyField;
        return value.selectField;
      } else {
        if (this.comboControl[field.name]) {
          this.oreResidue = undefined;
          this.dataMaskToSaveProg.fields.forEach(f => {
            if (f.name === field.name) {
              f.value = this.comboControl[field.name];
            }
          });
          field.value = this.comboControl[field.name];
          return this.comboControl[field.name];
        } else {

        }
      }
    }
  }

  checkFieldActivity(field: any): void {

    this.dataMaskToSaveProg.fields.forEach(f => {
      if (f.name === field.name) {
        f.value = this.comboControl[field.name];
      }
    });

    field.value = this.comboControl[field.name];
    this.comboValues[field.name].forEach(val => {
      if (!val.selectField.toLowerCase().includes(this.comboControl[field.name])) {
        val.visible = false;
      } else {
        val.visible = true;
      }
    });
  }

  addSelectedActivity(selected: any, field: any): void {
    this.fieldName = field.name;

    this.idContact = selected.option.value[2];
    let type;
    switch (field.name) {
      case 'To':
        type = '0';
        this.toField.nativeElement.value = '';
        this.toFieldData = new Array<any>();
        this.toCtrl = '';
        break;

    }
    this.apiService.getContactAddressBook(this.idContact, type).subscribe(res => {
      let fromFieldValue = new Object();

      if (!this.mapAddressBookSave) {
        this.mapAddressBookSave = new Array<any>();
      }
      this.addressBookSelectedToShow = [];

      this.addressBookSelectedToShow.push({name: selected.option.value[3], id: this.idContact});
      this.dataMaskToSaveProg.fields.forEach(df => {
        if (df.name === this.fieldName) {
          df.value = [];
          df.value.push(res);
        }
      });
      this.addressBookSelected.set(this.fieldName, [this.idContact]);
      this.mapAddressBookToSee.set(this.fieldName, this.addressBookSelectedToShow);
      this.apiService.getProfileValuesWithFilter('COMBO681_154', this.dataMaskToSaveProg.fields).subscribe(resu => {

        if (resu.dataSource) {
          this.fullComboValues = resu;
          this.tempCombo = new Array<any>();
          resu.dataSource.forEach(resds => {
            this.selectToAdd = '';
            this.keyToAdd = '';
            resds.columns.forEach(r => {
              if (resu.selectField.toLowerCase().includes(r.id.toLowerCase())) {
                this.selectToAdd += r.value + ' - ';
              }
              if (resu.keyField.toLowerCase().includes(r.id.toLowerCase())) {
                this.keyToAdd += r.value + ' - ';
              }
            });
            this.tempCombo.push({
              selectField: this.selectToAdd.substr(0, this.selectToAdd.length - 3),
              keyField: this.keyToAdd.substr(0, this.keyToAdd.length - 3),
              visible: true
            });
            this.comboValues['COMBO681_154'] = this.tempCombo;
            this.comboControl['COMBO681_154'] = new Array<any>();
          });
        }
      });
    });
  }

  openAddressBookActivity(field: any): void {
    if (!field.locked) {
      this.fieldName = field.name;

      this.apiService.SearchAllAddressBook().subscribe(results => {
        this.apiService.viewDataToShow = results;
        const name = field.name;
        if (field.description === 'Anagrafica cliente') {
          // name = 'From';
        } else {

        }
        const dialogRef = this.dialog.open(DialogAddressBookV2Component, {
          id: 'style-4',
          width: '80%',
          height: '95%',
          data: {
            enabledAddressBook: this.enableAddressBook,
            enableAddressBookFrom: this.enableAddressBookFrom,
            fieldName: name,
            addressBookSelected: this.addressBookSelected,
            selectField: 'DM_RUBRICA_RAGIONE_SOCIALE',

          }
        });


        dialogRef.afterClosed().subscribe(result => {
          this.mapAddressBookSave = new Array<any>();
          let fromFieldValue = new Object();
          this.addressBookSelectedToShow = [];
          // this.addressBookSelected = new Map<string, string[]>();
          let type: string;
          switch (this.fieldName) {
            case 'To':
              type = '0';
              break;
            case 'From':
              type = '1';
              break;
            case 'Cc':
              type = '2';
              break;
            case 'Senders':
              type = '3';
              break;
          }
          result.dataResult.forEach((val, index) => {

            this.idContact = val;
            this.apiService.getContactAddressBook(this.idContact, type).subscribe(res => {
              // // // console.log(res);
              if (type === '0' || type === '2') {
                this.mapAddressBookSave.push(res);
              }
              if (index === result.dataResult.length - 1) {
                if (result.dataResult !== false) {
                  result.contactsNames.forEach(item => {
                    this.addressBookSelectedToShow.push({name: item, id: val});
                  });
                  if (type === '0' || type === '2') {
                    this.dataMaskToSaveProg.fields.forEach(df => {
                      if (df.name === this.fieldName) {
                        df.value = [];
                        df.value.push(res);
                      }
                    });
                  } else {
                  }
                  this.addressBookSelected.set(this.fieldName, result.dataResult);
                  this.mapAddressBookToSee.set(this.fieldName, this.addressBookSelectedToShow);
                  this.apiService.getProfileValuesWithFilter('COMBO681_154', this.dataMaskToSaveProg.fields).subscribe(resu => {
                    this.comboControl['COMBO681_154'] = {};
                    this.comboValues = {};
                    if (resu.dataSource) {
                      this.fullComboValues = resu;
                      this.tempCombo = new Array<any>();
                      resu.dataSource.forEach(resds => {
                        this.selectToAdd = '';
                        this.keyToAdd = '';
                        resds.columns.forEach(r => {
                          if (resu.selectField.toLowerCase().includes(r.id.toLowerCase())) {
                            this.selectToAdd += r.value + ' - ';
                          }
                          if (resu.keyField.toLowerCase().includes(r.id.toLowerCase())) {
                            this.keyToAdd += r.value + ' - ';
                          }
                        });
                        this.tempCombo.push({
                          selectField: this.selectToAdd.substr(0, this.selectToAdd.length - 3),
                          keyField: this.keyToAdd.substr(0, this.keyToAdd.length - 3),
                          visible: true
                        });
                        this.comboValues['COMBO681_154'] = this.tempCombo;
                      });
                    }
                  });
                }

              }
            });
          });
        });
      });
    }
  }

  openTableDTOActivity(field: any): void {

    if (!field.locked) {

      this.fieldName = field.name;
      this.apiService.getProfileValuesWithFilter(field.name, this.dataMaskToSaveProg.fields).subscribe(results => {

        this.fieldDataSource = new Array<object>();
        if (results.dataSource != null) {
          this.keyField = results.keyField;
          results.dataSource.forEach(item => {
            this.fieldDataSource.push(item.columns);
          });
        } else {
          // EMPTY MULTI VALUE
        }
        const dialogRef = this.dialog.open(DialogTableDTOComponent, {
          id: 'style-4',
          width: '80%',
          height: '95%',
          data: {
            additionalFieldTableDTO: this.fieldDataSource,
            fieldName: field.name,
            tableValueToSelected: this.tableValuteDTOSelected,
            selectField: results.selectField
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          this.oreRimasteAttivita = result.dataResult['ORE RESIDUE'];
          this.attivitaValue = result.dataResult['DESCRIZIONE'];
          this.dataMaskToSaveProg.fields.forEach(f => {
            if (f.name === field.name) {
              f.value = result.dataResult['ID'];
            }
            if (f.name === 'TESTO680_154') {
              f.value = result.dataResult['DESCRIZIONE'];
            }
          });
        });
      });
    }
  }

  manualActivity(fieldName: string): void {
    this.oreRimasteAttivita = undefined;
    this.dataMaskToSaveProg.fields.forEach(f => {
      if (f.name === fieldName) {
        f.value = this.attivitaValue;
      }
      if (f.name === 'TESTO680_154') {
        f.value = this.attivitaValue;
      }
    });
  }

  getFieldValue(fieldName: string): string {
    this.dataMaskToSaveProg.fields.forEach(field => {
      if (field.name === fieldName) {
        return field.value;
      }
    });
    return '';
  }

  removeAddressBookActivity(v: any, fieldName: string): void {
    this.addressBookSelectedToShow = [];
    const tempSelected = [];
    this.dataMaskToSaveProg.fields.forEach(df => {
      if (df.name === fieldName) {
        df.value = [];
      }
    });
    this.mapAddressBookToSee = new Map<string, any>();
  }

  checkComboAssociationsActivity(field: any, keyFieldValue: number): void {
    // se cambia qualcosa nel campo combo non funziona piu

    let found = false;
    this.fullComboValues.dataSource.forEach(ds => {
      found = false;
      ds.columns.forEach(c => {

        if (c.id === 'ID' && c.value.toString() === keyFieldValue.toString()) {
          found = true;
        }

        if (c.id === 'ORE RESIDUE' && found === true) {
          this.oreResidue = c.value;
        }
      });
    });
    /*this.oreRimasteAttivita = result.dataResult['ORE RESIDUE'];
    this.attivitaValue = result.dataResult['DESCRIZIONE'];
    this.dataMaskToSaveProg.fields.forEach(f => {
      if (f.name === field.name){
        f.value = result.dataResult['ID'];
      }
      if (f.name === 'TESTO680_154'){
        f.value = result.dataResult['DESCRIZIONE'];
      }
    });*/
  }
  updateEventWhenStopTyping(event: any): void {
    // Clear the previous timeout, if any
    clearTimeout(this.typingTimeout);

    // Set a new timeout to execute the function after a delay
    this.typingTimeout = setTimeout(() => {
      this.apiService.getProfileSchemaSwitched(event.docN).subscribe(res => {
        res.fields.forEach(f => {
          if (f.name === 'TESTO12_12') {
            f.value = event.descrizione;
          }
        });
        this.updateProfile(res, event.docN);
      });
    }, 500); // Adjust the delay (in milliseconds) according to your needs
  }
  updateEvent(event: any): void {
    this.apiService.getProfileSchemaSwitched(event.docN).subscribe(res => {
      res.fields.forEach(f => {
        if (f.name === 'NUMERIC678_154') { // Ore previste
          f.value = event.hourNumber;
        }
        if (f.name === 'NUMERIC679_154') { // Ore effettive
          f.value = event.oreEffettive;
        }
      });
      this.updateProfile(res, event.docN);
    });
  }

  updateProfile(res: any, docN: string): void {
    this.apiService.updateProfile(res, docN).subscribe(profile => {

    });
  }

  newProgrammazione(): void {
    this.isAddNew = !this.isAddNew;
    if (this.isAddNew) {
      this.apiService.getProfileSchema('6de03aed607a4739bb6e0b82cc14676a').subscribe(res => {
        this.newActivityDescription = '';
        this.dataMaskToSaveProg = res;
        this.dataMaskToSaveProg.fields.forEach(v => {
          if (v.name === 'DataDoc') {
            v.value = this.TransformDataFormatToSave(this.selectedDay);
          }
        });
        this.ore = {
          NUMERIC678_154: 0,
          NUMERIC679_154: 0
        };
        this.comboControl = new Array<any>();
        this.mapAddressBookToSee = new Map<string, any>();
        this.addressBookSelectedToShow = {};
        this.mapAddressBookSave = new Array<any>();
        this.addressBookSelectedToShow = {};
        this.addressBookSelected = new Map<string, string[]>();
      });
    }
  }

  deleteEvent(event: any): void {

    this.apiService.deleteProfile(event.docN).subscribe(res => {
      this.events.forEach((e, index) => {
        if (e.docN === event.docN) {
          this.events.splice(index, 1);
        }
      });
    });
  }

  countOrePreviste(): number {
    let orePreviste = 0;
    this.events.forEach(v => {
      if (v.tecnico === this.selectedUser || this.selectedUser === '') {
        orePreviste += v['hourNumber'];
      }

    });
    return orePreviste;
  }

  countOreEffettive(): number {
    let oreEffettive = 0;
    this.events.forEach(v => {
      if (v.tecnico === this.selectedUser || this.selectedUser === '') {
        oreEffettive += v['oreEffettive'];
      }
    });
    return oreEffettive;
  }

  openProject(docN: string): void {
    window.open('https://next.betsoft-srl.it/ARXivarNextWebPortal/#!/profilation/' + docN + '/readonly/0f314b41b4f24f2bb0208f12c40c245b', '_blank');
  }


  sendRevision(): void {

  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  // FUNZIONI MASKDETAILS
  addSelected(selected: any, field: any): void {
    this.fieldName = field.name;

    this.idContact = selected.option.value[2];
    let type;
    switch (field.name) {
      case 'To':
        type = '0';
        this.toField.nativeElement.value = '';
        this.toFieldData = new Array<any>();
        this.toCtrl = '';
        break;
      case 'From':
        type = '1';
        this.fromField.nativeElement.value = '';
        this.fromCtrl = '';
        this.fromFieldData = new Array<any>();
        break;
      case 'Cc':
        type = '2';
        this.ccField.nativeElement.value = '';
        this.ccCtrl = '';
        this.ccFieldData = new Array<any>();
        break;
    }
    this.apiService.getContactAddressBook(this.idContact, type).subscribe(res => {
      let fromFieldValue = new Object();
      this.mapAddressBookSave = this.dataMaskToSave[this.fieldName];
      if (!this.mapAddressBookSave) {
        this.mapAddressBookSave = new Array<any>();
      }
      this.addressBookSelectedToShow = [];

      if (type === '0' || type === '2') {
        this.mapAddressBookSave.push(res);
        this.addressBookSelectedToShow = this.mapAddressBookToSee.get(field.name);
      } else {
        fromFieldValue = res;
        this.dataMaskToSave[this.fieldName] = fromFieldValue;
      }

      this.addressBookSelectedToShow.push({name: selected.option.value[3], id: this.idContact});
      if (type === '0' || type === '2') {
        this.dataMaskToSave[this.fieldName] = this.mapAddressBookSave;
      } else {
        this.dataMaskToSave[this.fieldName] = fromFieldValue;
      }
      this.addressBookSelected.set(this.fieldName, [this.idContact]);
      this.mapAddressBookToSee.set(this.fieldName, this.addressBookSelectedToShow);
      this.checkFormula();
      this.checkVisibility();
    });
  }

  checkAutocompleteTo(field: any): void {
    if (field.name === 'To') {
      if (this.toCtrl.length > 2) {
        this.apiService.SearchAddressBookFilter(this.toCtrl, field.addressBookDefaultFilter).subscribe(res => {
          console.log(res);
          this.toFieldData = res;
        });
      } else {
        this.toFieldData = new Array<any>();
      }
    } else if (field.name === 'From') {
      if (this.fromCtrl.length > 2) {
        this.apiService.SearchAddressBookFilter(this.fromCtrl, field.addressBookDefaultFilter).subscribe(res => {
          console.log(res);
          this.fromFieldData = res;
        });
      } else {
        this.fromFieldData = new Array<any>();
      }
    } else if (field.name === 'Cc') {
      if (this.ccCtrl.length > 2) {
        this.apiService.SearchAddressBookFilter(this.ccCtrl, field.addressBookDefaultFilter).subscribe(res => {
          console.log(res);
          this.ccFieldData = res;
        });
      } else {
        this.ccFieldData = new Array<any>();
      }
    }

  }

  ngOnInitMask(event: any): void {
    this.observable = new Observable(this.myObservableLoading);
    this.showProgressSpinner(this.observable);
    this.isNewRapportino = true;
    this.dataMaskToSave = {};
    this.comboControl = new Array<any>();
    this.comboValues = {};
    this.canProfile = true;
    this.badgeBufferMain = this.bufferIdInfo.length;
    this.dashColor = this.apiService.dashColor;
    this.backColor = this.apiService.backColor;
    this.squareColor = this.apiService.squareColor;
    this.cardColor = this.apiService.cardColor;
    this.breakpoint = (window.innerWidth <= 600) ? 4 : 6;
    if (this.isCteam) {
      this.id = this.idCteam;
    }
    this.apiService.getAoo().subscribe(data => {
      this.nomiAoo = data;
    });
    this.apiService.getOrigins().subscribe(data => {
      this.originsFields = data;
    });
    this.apiService.getDocumentType(this.id).subscribe(data => {
      this.documenTypes = data;
    });
    this.apiService.getStates().subscribe(data => {
      this.stateFields = data;
    });
    if (this.idTask === '0') {
      this.apiService.getProfileSchema(this.id).subscribe(data => {
        // // console.log(data);
        this.optionsMask = data.options;
        this.maskName = data.maskName;
        this.apiService.addPath(this.maskName, 'dashboard/dashnav/maskDetails', {
          id: this.id, idTask: this.idTask,
          operationId: this.operationId,
          path: this.path, firstnodepath: this.firstnodepath
        });
        this.apiService.namePath += ' - ' + this.maskName;
        this.splitMaskCat = this.maskName.split('-')[0];
        this.splitMaskOrder = this.maskName.split('-')[1];
        this.splitMaskName = this.maskName.split('-')[2];
        data.fields = data.fields.sort((a, b) => {
          return a.order - b.order;
        });
        this.fields = data.fields;
        data.fields.forEach(findClass => {
          if (findClass.visible) {
            this.dataMaskToSave[findClass.name] = findClass.value;
            this.dataValueAssociations[findClass.name] = findClass.associations;
          }

          if (findClass.className === 'DocumentDateFieldDTO') {
            findClass.value = this.TransformDataFormatToSave(this.todayDate.toDateString());
            this.dataMaskToSave[findClass.name] = this.TransformDataFormatToSave(this.todayDate.toDateString());
          }
          if (findClass.className === 'AdditionalFieldMultivalueDTO') {
            // console.log(findClass);
            this.dataMaskToSave[findClass.name] = findClass.value;
            this.multiValuteDTOSelectedToShow = new Array<any>();
            this.dataMaskToSave[findClass.name].forEach(v => {
              this.multiValuteDTOSelectedToShow.push(v);
            });
            this.mapMultiValueToSee.set(findClass.name, this.multiValuteDTOSelectedToShow);
          }
          if (findClass.className === 'AdditionalFieldClasseDTO') {
            this.mapClasseBookToSave.set(findClass.name, findClass.value);
            findClass.columns.forEach(column => {
              this.displayedColumnsClass.push(column.label);
            });
            this.displayedColumnsClass.push('Azioni');
            this.dataSourceClass = new MatTableDataSource(this.ELEMENT_DATA_CLASS);
          }
          if (findClass.className === 'ToFieldDTO') {
            const selected: Array<string> = new Array<string>('');
            this.enableAddressBook = findClass.enabledAddressBook;
            // // // console.log(findClass);
            this.addressBookSelectedToShow = [];
            if (findClass.value) {
              findClass.value.forEach(item => {
                // // // console.log(item);
                this.addressBookSelectedToShow.push({name: item.society, id: item.contactId});
                selected.push(item.contactId);

              });

              this.addressBookSelected.set(findClass.name, selected);
              // // // console.log(this.addressBookSelected);
              this.mapAddressBookToSee.set(findClass.name, this.addressBookSelectedToShow);
              // // // console.log(this.mapAddressBookToSee);
            } else {
              this.mapAddressBookToSee.set(findClass.name, []);
            }

          }
          if (findClass.className === 'FromFieldDTO') {
            const selected: Array<string> = new Array<string>('');
            this.enableAddressBookFrom = findClass.enabledAddressBook;
            this.addressBookSelectedToShow = [];
            if (findClass.value) {
              this.addressBookSelectedToShow.push({name: findClass.value.society, id: findClass.value.contactId});
              selected.push(findClass.value.contactId);
              // // // console.log(this.addressBookSelectedToShow);
              this.addressBookSelected.set(findClass.name, selected);
              this.mapAddressBookToSee.set(findClass.name, this.addressBookSelectedToShow);
              // // // console.log(this.mapAddressBookToSee);
            } else {
              this.mapAddressBookToSee.set(findClass.name, []);
            }


          }
          if (findClass.className === 'CcFieldDTO') {
            const selected: Array<string> = new Array<string>('');
            this.addressBookSelectedToShow = [];
            if (findClass.value) {
              findClass.value.forEach(item => {
                // // // console.log(item);
                this.addressBookSelectedToShow.push({name: item.society, id: item.contactId});
                selected.push(item.contactId);

              });
              this.addressBookSelected.set(findClass.name, selected);
              this.mapAddressBookToSee.set(findClass.name, this.addressBookSelectedToShow);
            } else {
              this.mapAddressBookToSee.set(findClass.name, []);
            }

          }
          if (findClass.className === 'DocumentTypeFieldDTO') {
            this.classProfileType = findClass.className;
            this.classProfileName = findClass.name;
            this.classProfileValue = findClass.value;
          }
        });
        this.fields.forEach(v => {

          if (v.className === 'AdditionalFieldComboDTO') {

            this.apiService.getProfileValuesWithFilter(v.name, this.getJsonFields().fields).subscribe(results => {

              if (results.dataSource) {
                this.tempCombo = new Array<any>();
                results.dataSource.forEach(res => {
                  this.selectToAdd = '';
                  this.keyToAdd = '';
                  res.columns.forEach(r => {
                    if (results.selectField.toLowerCase().includes(r.id.toLowerCase())) {
                      this.selectToAdd += r.value + ' - ';
                    }
                    if (results.keyField.toLowerCase().includes(r.id.toLowerCase())) {
                      this.keyToAdd += r.value + ' - ';
                    }
                  });
                  this.tempCombo.push({
                    selectField: this.selectToAdd.substr(0, this.selectToAdd.length - 3),
                    keyField: this.keyToAdd.substr(0, this.keyToAdd.length - 3),
                    visible: true
                  });
                  this.comboValues[v.name] = this.tempCombo;
                  let found = false;
                  if (!v.limitToList && v.value) {
                    this.comboValues[v.name].forEach(cycle => {
                      if (cycle.keyField === v.value) {
                        this.comboControl[v.name] = cycle.selectField;
                        found = true;
                      }
                    });
                    if (!found) {
                      this.comboControl[v.name] = v.value;
                    }
                  }
                });
              }
            });
          }
        });
        this.checkVisibility();
        // this.checkFormula();
        this.updateWithEventFields(event);

      }, errorLog => {
        this.snackBar.open(errorLog.error.userMessage, null, {
          duration: 5000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
          panelClass: ['mat-toolbar', 'custom-danger-bg']
        });
      });
    }
    // console.log(this.apiService.namePathV2);
  }

  updateWithEventFields(event: any): void {
    this.currentEventAddMask = event;
    this.apiService.getProfileSchemaSwitched(event.docN).subscribe(profile => {
      profile.fields.forEach(field => {
        if (field.name === 'CHECK682_154') {
          field.value = true; // Imposta stato rapportinato se salvato
          this.tempBodySetRapportinato = profile;
        }
        if (field.name === 'NUMERIC679_154') {
          const decimalHours = Math.floor(field.value);
          const minutes = Math.round((field.value - decimalHours) * 60);
          const HH = decimalHours.toString();
          const mm = minutes.toString().padStart(2, '0');
          this.dataMaskToSave['NUMERIC57_29'] = HH; // ore intervento
          this.dataMaskToSave['NUMERIC58_29'] = mm; // minuti intervento
        }
        if (field.name === 'TESTO12_12') {
          this.dataMaskToSave['TESTO12_12'] = field.value;
        }
        if (field.name === 'DataDoc') {
          this.dataMaskToSave['DATA1_12'] = field.value;
        }
        if (field.name === 'To') {
          this.dataMaskToSave[field.name] = field.value;
          const selected: Array<string> = new Array<string>('');
          field.value.forEach(item => {
            // // // console.log(item);
            this.addressBookSelectedToShow.push({name: item.society, id: item.contactId});
            selected.push(item.contactId);

          });
          this.addressBookSelected.set(field.name, selected);
          this.mapAddressBookToSee.set(field.name, this.addressBookSelectedToShow);
        }
        if (field.name === 'COMBO681_154') {
          this.apiService.getProfileValuesWithFilter('TABLE308_12', this.getJsonFields().fields).subscribe(results => {
            this.fieldName = 'TABLE308_12';
            this.tableAssociationField = {};
            this.tableAssociationField = Object.keys(results.associations)
              .reduce((c, k) => (c[k.toLowerCase()] = results.associations[k], c), {});
            const result = {dataResult: {}};
            if (results.dataSource != null) {
              this.keyField = results.keyField;
              let found = false;
              let selectedData: any;
              results.dataSource.forEach(item => {
                item.columns.forEach(c => {
                  if (c.id === 'ID') {
                    if (c.value.toString() === field.value.toString()) {
                      selectedData = item;
                    }
                  }
                });
              });
              if (!selectedData) {
                this.dialogRefSpinner.close();
                this.snackBar.open('ATTIVITA\' NON TROVATA', null, {
                  duration: 5000,
                  horizontalPosition: 'end',
                  verticalPosition: 'bottom',
                  panelClass: ['mat-toolbar', 'custom-danger-bg']
                });
              }else{
                selectedData.columns.forEach(column => {
                  result.dataResult[column.id] = column.value;
                });
              }
            }

            if (result.dataResult !== false && result.dataResult !== 'delete') {
              this.mapTableValueToSave = result.dataResult;
              this.fields.forEach((item, index) => {
                if (this.tableAssociationField.hasOwnProperty(item.name.toLowerCase())) {
                  if (item.name.startsWith('DATA')) {
                    this.fields[index].value = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                    this.dataMaskToSave[this.fields[index].name] = new Date(this.TransformDataFormatToSave(result.dataResult[this.tableAssociationField[item.name.toLowerCase()]]));
                  } else {
                    if (this.fields[index].className === 'AdditionalFieldComboDTO' && !this.fields[index].limitToList) {
                      this.fields[index].value = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                      this.dataMaskToSave[this.fields[index].name] = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                      this.comboControl[this.fields[index].name] = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                    } else {
                      this.fields[index].value = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                      this.dataMaskToSave[this.fields[index].name] = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                    }
                  }
                }
                if (item.name === this.fieldName) {
                  if (item.name.startsWith('DATA')) {
                    this.fields[index].value = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                    this.dataMaskToSave[this.fields[index].name] = new Date(this.TransformDataFormatToSave(result.dataResult[this.tableAssociationField[item.name.toLowerCase()]]));
                  } else {
                    this.fields[index].value = result.dataResult[this.keyField];
                    this.dataMaskToSave[this.fields[index].name] = result.dataResult[this.keyField];
                  }
                }
              });
            }
            // console.log(this.fields);
            // console.log(this.dataMaskToSave);

            this.getAllProfileValue();

            this.dialogRefSpinner.close();
          });
        }

      });
    });
  }

  checkField(field: any): void {
    this.dataMaskToSave[field.name] = this.comboControl[field.name];
    field.value = this.comboControl[field.name];
    this.comboValues[field.name].forEach(val => {
      if (!val.selectField.toLowerCase().includes(this.comboControl[field.name])) {
        val.visible = false;
      } else {
        val.visible = true;
      }
    });
  }

  displayFn(field: any, value?: any): any {

    if (value) {
      if (value.keyField){
        this.dataMaskToSave[field.name] = value.keyField;
        field.value = value.keyField;
        return value.selectField;
      }else{
        if (this.comboControl[field.name]) {
          this.dataMaskToSave[field.name] = this.comboControl[field.name];
          field.value = this.comboControl[field.name];
          return this.comboControl[field.name];
        } else {

        }
      }

    } else {
      if (this.comboControl[field.name]) {
        this.dataMaskToSave[field.name] = this.comboControl[field.name];
        field.value = this.comboControl[field.name];
        return this.comboControl[field.name];
      } else {

      }
    }

  }


  changeEditCombo(name: string): void {
    this.editCombo[name] = !this.editCombo[name];
  }

  openMultiValueDTO(field: any): void {
    if (!field.locked) {
      this.fieldName = field.name;
      this.apiService.getProfileValuesWithFilter(field.name, this.getJsonFields().fields).subscribe(results => {
        // // console.log(results);
        this.fieldDataSource = new Array<object>();
        if (results.dataSource != null) {
          results.dataSource.forEach(item => {
            this.fieldDataSource.push(item.columns);
          });
        } else {
          // EMPTY MULTI VALUE
        }
        const dialogRef = this.dialog.open(DialogMultiDTOComponent, {
          id: 'style-4',
          width: '40%',
          height: '60%',
          data: {
            additionalFieldMultiDTO: this.fieldDataSource,
            fieldName: field.name,
            multiValueToSelected: this.multiValuteDTOSelected,
            selectField: results.keyField
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          // console.log(result);
          if (result.dataResult === 'delete') {
            this.multiValuteDTOSelectedToShow = new Array<any>();
            this.dataMaskToSave[this.fieldName] = '';
            this.mapMultiValueToSee.set(this.fieldName, '');
            this.multiValuteDTOSelected.set(this.fieldName, []);
          }
          this.multiValuteDTOSelectedToShow = new Array<any>();
          if (result.dataResult !== false) {
            result.dataResult.forEach(item => {
              this.multiValuteDTOSelectedToShow.push(item);
            });
            this.dataMaskToSave[this.fieldName] = result.dataResult;
            this.mapMultiValueToSave.set(this.fieldName, result.dataToSave); // non serve probabilmente
            this.multiValuteDTOSelected.set(this.fieldName, result.dataResult);
            this.mapMultiValueToSee.set(this.fieldName, this.multiValuteDTOSelectedToShow);
          }
          this.getAllProfileValue();
          this.checkFormula();
        });
      });
    }
  }

  checkComboAssociations(field: any): void {
    let comboResult: any = {};
    let selectedElement;
    this.fieldName = field.name;
    console.log(this.dataMaskToSave[field.name]);
    this.apiService.getProfileValuesWithFilter(field.name, this.getJsonFields().fields).subscribe(results => {

      comboResult = results;
      this.comboAssociationField = {};
      this.comboAssociationField = Object.keys(results.associations);
      this.fieldDataSource = new Array<any>();
      this.keyField = results.keyField;
      if (results.dataSource != null) {

        results.dataSource.forEach(item => {
          item.columns.forEach(v => {
            if (v.id.toUpperCase() === this.keyField.toUpperCase()) {
              if (v.value.toString() === field.value.toString()) {
                v.value = this.dataMaskToSave[field.name];
                selectedElement = item;
              }
            }
          });

        });
      } else {
        // EMPTY COMBO
      }
      console.log(selectedElement);
      this.comboAssociationField.forEach(res => {
        if (selectedElement) {
          selectedElement.columns.forEach(v2 => {

            if (v2.id === comboResult.associations[res]) {
              if (res.toUpperCase().startsWith('DATA')) {
                this.dataMaskToSave[res.toUpperCase()] = this.TransformDataFormatToSave(v2.value);
              } else {
                this.dataMaskToSave[res.toUpperCase()] = v2.value;
              }

            }
          });
        }
      });
      console.log(this.fields);
      this.tempSkipProfileValue = field.name;
      this.getAllProfileValue();
    });
  }

  checkInputFormula(): void {
    this.formulaCalculatorNoLoading(0);
    this.progressSpinnerValue = 100;
  }

  formulaCalculatorNoLoading(i: number): void {

    let pastFormulas: Array<any> = new Array<any>();
    let found = false;
    pastFormulas = new Array<any>();
    if (this.fields[i].formula) {
      found = false;
      pastFormulas.push({name: this.fields[i].name, formula: this.fields[i].formula});
      pastFormulas.forEach(pf => {
        if (pf.formula.toString().includes(this.fields[i].name.toString())) {
          this.apiService.getProfileFormula(this.getUpdatedFields(this.fields[i].name, this.fields[i].formula)).subscribe(res => {
            if (this.fields[i].className === 'AdditionalFieldDateTimeDTO') {
              this.dataMaskToSave[this.fields[i].name] = moment(res.replace(' 00:00:00', ''), 'DD/MM/YYYY').toDate();
            } else {
              this.dataMaskToSave[this.fields[i].name] = res;
            }
            if (this.fields[i + 1]) {
              this.formulaCalculatorNoLoading(i + 1);
            }
            found = true;
            this.apiService.getProfileFormula(this.getUpdatedFields(pf.name, pf.formula)).subscribe(res2 => {
              if (pf.className === 'AdditionalFieldDateTimeDTO') {
                this.dataMaskToSave[pf.name] = moment(res2.replace(' 00:00:00', ''), 'DD/MM/YYYY').toDate();
              } else {
                this.dataMaskToSave[pf.name] = res2;
              }
              if (!this.fields[i + 1]) {
                this.checkVisibility();
                this.progressSpinnerValue = 100;
                this.getAllNullProfileValue();
              }
            });
          });
        }
      });
      if (!found) {
        this.apiService.getProfileFormula(this.getUpdatedFields(this.fields[i].name, this.fields[i].formula)).subscribe(res => {
          if (this.fields[i].className === 'AdditionalFieldDateTimeDTO') {
            this.dataMaskToSave[this.fields[i].name] = moment(res.replace(' 00:00:00', ''), 'DD/MM/YYYY').toDate();
          } else {
            this.dataMaskToSave[this.fields[i].name] = res;
          }
          if (this.fields[i + 1]) {
            this.formulaCalculatorNoLoading(i + 1);
          }
          if (!this.fields[i + 1]) {
            this.checkVisibility();
            this.progressSpinnerValue = 100;
            this.getAllNullProfileValue();
          }
          this.fields.forEach(field => {
            if (field.formula) {
              if (field.formula.toString().includes(this.fields[i].name)) {
                this.apiService.getProfileFormula(this.getUpdatedFields(field.name, field.formula)).subscribe(res2 => {
                  if (field.className === 'AdditionalFieldDateTimeDTO') {
                    this.dataMaskToSave[field.name] = moment(res2.replace(' 00:00:00', ''), 'DD/MM/YYYY').toDate();
                  } else {
                    this.dataMaskToSave[field.name] = res2;
                  }
                  if (!this.fields[i + 1]) {
                    this.checkVisibility();
                    this.progressSpinnerValue = 100;
                    this.getAllNullProfileValue();
                  }
                });
              }
            }

          });
        });
      }
    } else {
      if (this.fields[i + 1]) {
        this.formulaCalculatorNoLoading(i + 1);
      } else {
        this.checkVisibility();
        this.progressSpinnerValue = 100;
        this.getAllNullProfileValue();
      }
    }
  }

  checkFormula(): void {

    this.formulaCalculator(0);
    // this.progressSpinnerValue = 100;
  }

  formulaCalculator(i: number): void {

    let pastFormulas: Array<any> = new Array<any>();
    let found = false;
    pastFormulas = new Array<any>();
    if (this.fields[i].formula) {
      found = false;
      pastFormulas.push({name: this.fields[i].name, formula: this.fields[i].formula});
      pastFormulas.forEach(pf => {
        if (pf.formula.toString().includes(this.fields[i].name.toString())) {
          this.apiService.getProfileFormula(this.getUpdatedFields(this.fields[i].name, this.fields[i].formula)).subscribe(res => {
            if (this.fields[i].className === 'AdditionalFieldDateTimeDTO') {
              this.dataMaskToSave[this.fields[i].name] = moment(res.replace(' 00:00:00', ''), 'DD/MM/YYYY').toDate();
            } else {
              this.dataMaskToSave[this.fields[i].name] = res;
            }

            this.progressSpinnerValue = i / this.fields.length * 100;
            if (this.fields[i + 1]) {
              this.formulaCalculator(i + 1);
            }
            found = true;

            this.apiService.getProfileFormula(this.getUpdatedFields(pf.name, pf.formula)).subscribe(res2 => {
              if (pf.className === 'AdditionalFieldDateTimeDTO') {
                this.dataMaskToSave[pf.name] = moment(res2.replace(' 00:00:00', ''), 'DD/MM/YYYY').toDate();
              } else {
                this.dataMaskToSave[pf.name] = res2;
              }
              if (!this.fields[i + 1]) {
                this.checkVisibility();
                this.progressSpinnerValue = 100;
                this.getAllNullProfileValue();
              }
            });
          });
        }
      });
      if (!found) {
        this.apiService.getProfileFormula(this.getUpdatedFields(this.fields[i].name, this.fields[i].formula)).subscribe(res => {
          if (this.fields[i].className === 'AdditionalFieldDateTimeDTO') {
            this.dataMaskToSave[this.fields[i].name] = moment(res.replace(' 00:00:00', ''), 'DD/MM/YYYY').toDate();
          } else {
            this.dataMaskToSave[this.fields[i].name] = res;
          }
          this.progressSpinnerValue = i / this.fields.length * 100;
          if (this.fields[i + 1]) {
            this.formulaCalculator(i + 1);
          }
          if (!this.fields[i + 1]) {
            this.checkVisibility();
            this.progressSpinnerValue = 100;
            this.getAllNullProfileValue();
          }
          this.fields.forEach(field => {
            if (field.formula) {
              if (field.formula.toString().includes(this.fields[i].name)) {
                this.apiService.getProfileFormula(this.getUpdatedFields(field.name, field.formula)).subscribe(res2 => {
                  if (field.className === 'AdditionalFieldDateTimeDTO') {
                    this.dataMaskToSave[field.name] = moment(res2.replace(' 00:00:00', ''), 'DD/MM/YYYY').toDate();
                  } else {
                    this.dataMaskToSave[field.name] = res2;
                  }
                  if (!this.fields[i + 1]) {
                    this.checkVisibility();
                    this.progressSpinnerValue = 100;
                    this.getAllNullProfileValue();
                  }
                });
              }
            }

          });
        });
      }
    } else {
      if (this.fields[i + 1]) {
        let ind = i + 1;
        this.formulaCalculator(i + 1);
      } else {
        this.checkVisibility();
        this.progressSpinnerValue = 100;
        this.getAllNullProfileValue();
      }
    }
  }

  getUpdatedFields(name: string, form: string): any {
    this.jsonToSendArxivar =
      {
        fieldName: name,
        formula: form,
        searchFilterDto: {
          fields: []
        }
      };
    this.fields.forEach((field, index) => {
      if (field.visible || this.dataMaskToSave[field.name]) {
        if (field.className === 'AdditionalFieldDateTimeDTO') {
          this.fields[index].value = this.TransformDataFormatToSave(this.dataMaskToSave[field.name]);
        } else if (field.className === 'AdditionalFieldDoubleDTO') {
          if (this.dataMaskToSave[field.name]) {
            this.fields[index].value = (this.dataMaskToSave[field.name].toString().replace(',', '.'));
          } else {
            this.fields[index].value = this.dataMaskToSave[field.name];
          }
        } else {
          this.fields[index].value = this.dataMaskToSave[field.name];
        }
      }
      this.jsonToSendArxivar.searchFilterDto.fields.push(this.fields[index]);
    });
    return this.jsonToSendArxivar;
  }

  remove(v: string, fieldName: string): void {
    this.multiValuteDTOSelectedToShow = new Array<any>();
    this.dataMaskToSave[fieldName].forEach((value, index) => {
      if (value === v) {
        this.dataMaskToSave[fieldName].splice(index, 1);
      }
    });
    this.dataMaskToSave[fieldName].forEach((value) => {
      this.multiValuteDTOSelectedToShow.push(value);
    });
    this.mapMultiValueToSee.set(fieldName, this.multiValuteDTOSelectedToShow);
  }

  removeAddressBook(v: any, fieldName: string): void {
    this.addressBookSelectedToShow = [];
    const tempSelected = [];
    if (fieldName === 'To') {

      this.dataMaskToSave[fieldName].forEach((value, index) => {
        if (value.contactId === v.id) {
          this.dataMaskToSave[fieldName].splice(index, 1);
        }
      });
      this.dataMaskToSave[fieldName].forEach((value) => {
        this.addressBookSelectedToShow.push({name: value.society, id: value.contactId});
        tempSelected.push(value.contactId);
      });

    } else {
      this.dataMaskToSave[fieldName].value = {};
    }
    this.mapAddressBookToSee.set(fieldName, this.addressBookSelectedToShow);
    this.addressBookSelected.set(fieldName, tempSelected);
  }

  checkVisibility(): void {
    setTimeout(() => {
      this.checkMandatory();
      let pastFormulas: Array<any> = new Array<any>();
      const found = false;
      pastFormulas = new Array<any>();
      // // console.log(this.fields);
      this.fields.forEach(f => {
        if (f.visibilityCondition === null || f.visibilityCondition === '') {
        } else {
          const splittedConditions: Array<string> = new Array<string>();
          const operators: Array<string> = new Array<string>();
          let condition = f.visibilityCondition;
          let end = false;
          const i = 0;
          let result = false;
          while (!end) {
            if (condition.includes('||') && condition.includes('&&')) {
              if (condition.indexOf('||') < condition.indexOf('&&')) {
                splittedConditions.push(condition.split('||')[0]);
                condition = condition.substring(condition.indexOf('||') + 2, condition.length);
                operators.push('||');
              } else {
                splittedConditions.push(condition.split('&&')[0]);
                condition = condition.substring(condition.indexOf('&&') + 2, condition.length);
                operators.push('&&');
              }
            } else if (condition.includes('||')) {
              splittedConditions.push(condition.split('||')[0]);
              condition = condition.substring(condition.indexOf('||') + 2, condition.length);
              operators.push('||');
            } else if (condition.includes('&&')) {
              splittedConditions.push(condition.split('&&')[0]);
              condition = condition.substring(condition.indexOf('&&') + 2, condition.length);
              operators.push('&&');
            } else {
              splittedConditions.push(condition);
              end = true;
            }
          }

          splittedConditions.forEach((cond, index) => {
            let field: string;
            let equalTo: string;
            let isNotEqual: boolean;
            let conditionBeforeBrackets;
            if (cond.includes('<>')) {
              equalTo = cond.substring(cond.indexOf('<>') + 2, cond.length).trim().split('\'').join('');
              field = cond.substring(0, cond.indexOf('<>')).trim();
              isNotEqual = true;
            } else {
              equalTo = cond.substring(cond.indexOf('=') + 1, cond.length).trim().split('\'').join('');
              field = cond.substring(0, cond.indexOf('=')).trim();
              isNotEqual = false;
            }

            /*equalTo = equalTo.split(')').join('');
            equalTo = equalTo.split('(').join('');*/

            if (!isNotEqual) {
              /* console.log(this.dataMaskToSave[field]);
               console.log(equalTo);*/
              if ((this.dataMaskToSave[field] !== null && equalTo !== null) && (this.dataMaskToSave[field] !== undefined && equalTo !== undefined)) {
                if (equalTo.toString().trim().charCodeAt(0) === 62 && equalTo.toString().trim().length === 1) {
                  equalTo = '';
                }
                if (this.dataMaskToSave[field].toString().trim() === equalTo.toString().trim()) {
                  // // console.log('la condizione è vera: ' + cond);
                  if (index !== 0 && result === false) {
                    if (operators[index - 1] === '&&') {
                      result = false;
                    } else {
                      result = true;
                    }
                  } else {
                    /*// console.log('Risultato ----- ');
                    // console.log('-----------------------' + cond);
                    // console.log(this.dataMaskToSave[field].toString().trim() as string);
                    // console.log(equalTo.toString().trim() as string);
                    // console.log('LUNGHEZZA ' + equalTo.toString().trim().length);
                    if (this.dataMaskToSave[field].toString().trim() as string !== equalTo.toString().trim() as string) {
                      // console.log('entrato è vero!!!!');
                    }*/
                    result = true;
                  }

                } else {
                  // // console.log('la condizione è falsa: ' + cond);
                  if (index !== 0) {
                    if (operators[index - 1] === '&&') {
                      result = false;
                    } else {

                    }
                  } else {
                    result = false;
                  }

                }
              } else {
                result = false;
              }
            } else {
              if ((this.dataMaskToSave[field] !== null && equalTo !== null) && (this.dataMaskToSave[field] !== undefined && equalTo !== undefined)) {
                if (equalTo.toString().trim().charCodeAt(0) === 62 && equalTo.toString().trim().length === 1) {
                  equalTo = '';
                }

                if (this.dataMaskToSave[field].toString().trim() !== equalTo.toString().trim()) {
                  if (index !== 0 && result === false) {
                    if (operators[index - 1] === '&&') {
                      result = false;
                    } else {
                      result = true;
                    }
                  } else {
                    /*// console.log('Risultato ----- ');
                    // console.log('-----------------------' + cond);
                    // console.log(this.dataMaskToSave[field].toString().trim() as string);
                    // console.log(equalTo.toString().trim() as string);
                    // console.log('LUNGHEZZA ' + equalTo.toString().trim().length);
                    if (this.dataMaskToSave[field].toString().trim() as string !== equalTo.toString().trim() as string) {
                      // console.log('entrato è vero!!!!');
                    }*/
                    result = true;
                  }
                } else {
                  if (index !== 0) {
                    if (operators[index - 1] === '&&') {
                      result = false;
                    } else {

                    }
                  } else {
                    result = false;
                  }

                }
              } else {
                result = false;
              }
            }
            /*if (f.name === 'TABLE308_12'){
                // console.log(result);
                // console.log(cond);
                // console.log(equalTo.toString().trim());
                // console.log(this.dataMaskToSave);
            }*/
          });
          f.visible = result;
        }
      });
    }, 1);
  }

  checkMandatory(): void {
    setTimeout(() => {
      let pastFormulas: Array<any> = new Array<any>();
      const found = false;
      pastFormulas = new Array<any>();
      // // console.log(this.fields);
      this.fields.forEach(f => {
        if (f.mandatoryCondition === null || f.mandatoryCondition === '') {
        } else {
          const splittedConditions: Array<string> = new Array<string>();
          const operators: Array<string> = new Array<string>();
          let condition = f.mandatoryCondition;
          let end = false;
          const i = 0;
          let result = false;
          while (!end) {
            if (condition.includes('||') && condition.includes('&&')) {
              if (condition.indexOf('||') < condition.indexOf('&&')) {
                splittedConditions.push(condition.split('||')[0]);
                condition = condition.substring(condition.indexOf('||') + 2, condition.length);
                operators.push('||');
              } else {
                splittedConditions.push(condition.split('&&')[0]);
                condition = condition.substring(condition.indexOf('&&') + 2, condition.length);
                operators.push('&&');
              }
            } else if (condition.includes('||')) {
              splittedConditions.push(condition.split('||')[0]);
              condition = condition.substring(condition.indexOf('||') + 2, condition.length);
              operators.push('||');
            } else if (condition.includes('&&')) {
              splittedConditions.push(condition.split('&&')[0]);
              condition = condition.substring(condition.indexOf('&&') + 2, condition.length);
              operators.push('&&');
            } else {
              splittedConditions.push(condition);
              end = true;
            }
          }

          splittedConditions.forEach((cond, index) => {
            let field: string;
            let equalTo: string;
            let isNotEqual: boolean;
            let conditionBeforeBrackets;
            if (cond.includes('<>')) {
              equalTo = cond.substring(cond.indexOf('<>') + 2, cond.length).trim().split('\'').join('');
              field = cond.substring(0, cond.indexOf('<>')).trim();
              isNotEqual = true;
            } else {
              equalTo = cond.substring(cond.indexOf('=') + 1, cond.length).trim().split('\'').join('');
              field = cond.substring(0, cond.indexOf('=')).trim();
              isNotEqual = false;
            }

            /*equalTo = equalTo.split(')').join('');
            equalTo = equalTo.split('(').join('');*/

            if (!isNotEqual) {
              /* console.log(this.dataMaskToSave[field]);
               console.log(equalTo);*/
              if ((this.dataMaskToSave[field] !== null && equalTo !== null) && (this.dataMaskToSave[field] !== undefined && equalTo !== undefined)) {
                if (equalTo.toString().trim().charCodeAt(0) === 62 && equalTo.toString().trim().length === 1) {
                  equalTo = '';
                }
                if (this.dataMaskToSave[field].toString().trim() === equalTo.toString().trim()) {
                  // // console.log('la condizione è vera: ' + cond);
                  if (index !== 0 && result === false) {
                    if (operators[index - 1] === '&&') {
                      result = false;
                    } else {
                      result = true;
                    }
                  } else {
                    /*// console.log('Risultato ----- ');
                    // console.log('-----------------------' + cond);
                    // console.log(this.dataMaskToSave[field].toString().trim() as string);
                    // console.log(equalTo.toString().trim() as string);
                    // console.log('LUNGHEZZA ' + equalTo.toString().trim().length);
                    if (this.dataMaskToSave[field].toString().trim() as string !== equalTo.toString().trim() as string) {
                      // console.log('entrato è vero!!!!');
                    }*/
                    result = true;
                  }

                } else {
                  // // console.log('la condizione è falsa: ' + cond);
                  if (index !== 0) {
                    if (operators[index - 1] === '&&') {
                      result = false;
                    } else {

                    }
                  } else {
                    result = false;
                  }

                }
              } else {
                result = false;
              }
            } else {
              if ((this.dataMaskToSave[field] !== null && equalTo !== null) && (this.dataMaskToSave[field] !== undefined && equalTo !== undefined)) {
                if (equalTo.toString().trim().charCodeAt(0) === 62 && equalTo.toString().trim().length === 1) {
                  equalTo = '';
                }

                if (this.dataMaskToSave[field].toString().trim() !== equalTo.toString().trim()) {
                  if (index !== 0 && result === false) {
                    if (operators[index - 1] === '&&') {
                      result = false;
                    } else {
                      result = true;
                    }
                  } else {
                    /*// console.log('Risultato ----- ');
                    // console.log('-----------------------' + cond);
                    // console.log(this.dataMaskToSave[field].toString().trim() as string);
                    // console.log(equalTo.toString().trim() as string);
                    // console.log('LUNGHEZZA ' + equalTo.toString().trim().length);
                    if (this.dataMaskToSave[field].toString().trim() as string !== equalTo.toString().trim() as string) {
                      // console.log('entrato è vero!!!!');
                    }*/
                    result = true;
                  }
                } else {
                  if (index !== 0) {
                    if (operators[index - 1] === '&&') {
                      result = false;
                    } else {

                    }
                  } else {
                    result = false;
                  }

                }
              } else {
                result = false;
              }
            }
            /*if (f.name === 'TABLE308_12'){
                // console.log(result);
                // console.log(cond);
                // console.log(equalTo.toString().trim());
                // console.log(this.dataMaskToSave);
            }*/
          });
          f.required = result;
        }
      });
    }, 1);
  }

  showProgressSpinnerUntilExecuted(observable: Observable<any>): void {
    const dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    const subscription = observable.subscribe(
      (response: any) => {
        subscription.unsubscribe();
        // handle response
        // console.log(response);
        dialogRef.close();
      },
      (error) => {
        subscription.unsubscribe();
        // handle error
        dialogRef.close();
      }
    );
  }

  showProgressSpinner(observable: Observable<any>): void {
    this.dialogRefSpinner = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    const subscription = observable.subscribe(
      (response: any) => {
        subscription.unsubscribe();
        // handle response
        // console.log(response);
        this.dialogRefSpinner.close();
      },
      (error) => {
        subscription.unsubscribe();
        // handle error
        this.dialogRefSpinner.close();
      }
    );
  }

  myObservableFast(observer): void {
    setTimeout(() => {
      observer.next('done waiting for 5 sec');
      observer.complete();
    }, 500);
  }

  myObservableLoading(observer): void {

  }

  openTableDTO(field: any): void {

    if (!field.locked) {
      this.observable = new Observable(this.myObservableFast);
      this.showProgressSpinnerUntilExecuted(this.observable);
      this.fieldName = field.name;
      this.apiService.getProfileValuesWithFilter(field.name, this.getJsonFields().fields).subscribe(results => {
        this.tableAssociationField = {};
        this.tableAssociationField = Object.keys(results.associations)
          .reduce((c, k) => (c[k.toLowerCase()] = results.associations[k], c), {});
        this.fieldDataSource = new Array<object>();
        if (results.dataSource != null) {
          this.keyField = results.keyField;
          results.dataSource.forEach(item => {
            this.fieldDataSource.push(item.columns);
          });
        } else {
          // EMPTY MULTI VALUE
        }
        const dialogRef = this.dialog.open(DialogTableDTOComponent, {
          id: 'style-4',
          width: '80%',
          height: '95%',
          data: {
            additionalFieldTableDTO: this.fieldDataSource,
            fieldName: field.name,
            tableValueToSelected: this.tableValuteDTOSelected,
            selectField: results.selectField
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          // console.log(result);
          // console.log(this.tableAssociationField);
          if (result.dataResult === 'delete') {
            this.fields.forEach((item, index) => {
              if (this.tableAssociationField.hasOwnProperty(item.name.toLowerCase())) {
                this.fields[index].value = '';
                this.dataMaskToSave[this.fields[index].name] = '';
              }
              if (item.name === this.fieldName) {
                this.fields[index].value = '';
                this.dataMaskToSave[this.fields[index].name] = '';
              }
            });
          }
          if (result.dataResult !== false && result.dataResult !== 'delete') {
            this.mapTableValueToSave = result.dataResult;
            this.fields.forEach((item, index) => {
              if (this.tableAssociationField.hasOwnProperty(item.name.toLowerCase())) {
                if (item.name.startsWith('DATA')) {
                  this.fields[index].value = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                  this.dataMaskToSave[this.fields[index].name] = new Date(this.TransformDataFormatToSave(result.dataResult[this.tableAssociationField[item.name.toLowerCase()]]));
                } else {
                  if (this.fields[index].className === 'AdditionalFieldComboDTO' && !this.fields[index].limitToList) {
                    this.fields[index].value = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                    this.dataMaskToSave[this.fields[index].name] = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                    this.comboControl[this.fields[index].name] = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                  } else {
                    this.fields[index].value = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                    this.dataMaskToSave[this.fields[index].name] = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                  }
                }
              }
              if (item.name === this.fieldName) {
                if (item.name.startsWith('DATA')) {
                  this.fields[index].value = result.dataResult[this.tableAssociationField[item.name.toLowerCase()]];
                  this.dataMaskToSave[this.fields[index].name] = new Date(this.TransformDataFormatToSave(result.dataResult[this.tableAssociationField[item.name.toLowerCase()]]));
                } else {
                  this.fields[index].value = result.dataResult[this.keyField];
                  this.dataMaskToSave[this.fields[index].name] = result.dataResult[this.keyField];
                }
              }
            });
          }
          // console.log(this.fields);
          // console.log(this.dataMaskToSave);
          this.getAllProfileValue();
        });
      });
    }
  }

  openAddressBook(field: any): void {
    if (!field.locked) {
      this.fieldName = field.name;
      this.observable = new Observable(this.myObservableFast);
      this.showProgressSpinnerUntilExecuted(this.observable);
      this.apiService.SearchAllAddressBook().subscribe(results => {
        this.apiService.viewDataToShow = results;
        const name = field.name;
        if (field.description === 'Anagrafica cliente') {
          // name = 'From';
        } else {

        }
        const dialogRef = this.dialog.open(DialogAddressBookV2Component, {
          id: 'style-4',
          width: '80%',
          height: '95%',
          data: {
            enabledAddressBook: this.enableAddressBook,
            enableAddressBookFrom: this.enableAddressBookFrom,
            fieldName: name,
            addressBookSelected: this.addressBookSelected,
            selectField: 'DM_RUBRICA_RAGIONE_SOCIALE',

          }
        });


        dialogRef.afterClosed().subscribe(result => {
          this.mapAddressBookSave = new Array<any>();
          let fromFieldValue = new Object();
          this.addressBookSelectedToShow = [];
          // this.addressBookSelected = new Map<string, string[]>();
          let type: string;
          switch (this.fieldName) {
            case 'To':
              type = '0';
              break;
            case 'From':
              type = '1';
              break;
            case 'Cc':
              type = '2';
              break;
            case 'Senders':
              type = '3';
              break;
          }
          result.dataResult.forEach((val, index) => {

            this.idContact = val;
            this.apiService.getContactAddressBook(this.idContact, type).subscribe(res => {
              // // // console.log(res);
              if (type === '0' || type === '2') {
                this.mapAddressBookSave.push(res);
              } else {
                fromFieldValue = res;
                this.dataMaskToSave[this.fieldName] = fromFieldValue;
              }
              if (index === result.dataResult.length - 1) {
                if (result.dataResult !== false) {
                  result.contactsNames.forEach(item => {
                    this.addressBookSelectedToShow.push({name: item, id: val});
                  });
                  if (type === '0' || type === '2') {
                    this.dataMaskToSave[this.fieldName] = this.mapAddressBookSave;
                  } else {
                    this.dataMaskToSave[this.fieldName] = fromFieldValue;
                  }
                  this.addressBookSelected.set(this.fieldName, result.dataResult);
                  this.mapAddressBookToSee.set(this.fieldName, this.addressBookSelectedToShow);
                }

                this.checkFormula();
                this.getAllProfileValue();
              }
            });
          });
        });
      });
    }
  }


  deleteNote(note: any): void {
    this.notes.forEach((v, index) => {
      if (v.comment === note.comment) {
        this.notes.splice(index, 1);
        this.snackBar.open('Nota eliminata correttamente', null, {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
          panelClass: ['mat-toolbar', 'custom-warning-bg']
        });
      }
    });
  }

  addNote(): void {
    if (this.addNoteText !== '') {
      this.notes.push({
        aosflag: false,
        comment: this.addNoteText,
        docnumber: null,
        isEdit: false,
        isPaNote: false
      });
      this.snackBar.open('Nota aggiunta correttamente', null, {
        duration: 3000,
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['mat-toolbar', 'custom-success-bg']
      });
    }
    this.addNoteText = '';
  }

  insertMaskFromClassDTO(field: any): void {
    if (!field.locked) {
      if (this.bufferIdInfo.length > 0) {
        this.jsonToSendArxivar = {
          document: {
            fileNames: [],
            bufferIds: []
          },
          fields: [],
          notes: this.notes
        };
        this.bufferIdInfo.forEach(file => {
          this.jsonToSendArxivar.document.fileNames.push(file.name);
          this.jsonToSendArxivar.document.bufferIds.push(file.buffer);
        });
      } else {
        this.jsonToSendArxivar = {
          fields: [],
          notes: this.notes
        };
      }
      this.fields.forEach((field1, index) => {
        if (field1.visible) {
          // // // // console.log(this.dataMaskToSave);
          if (field1.className === 'AdditionalFieldDateTimeDTO') {
            this.fields[index].value = this.TransformDataFormatToSave(this.dataMaskToSave[field1.name]);
          } else if (field1.className === 'AdditionalFieldDoubleDTO') {
            if (this.dataMaskToSave[field1.name]) {
              this.fields[index].value = (this.dataMaskToSave[field1.name].toString().replace(',', '.'));
            } else {
              this.fields[index].value = this.dataMaskToSave[field1.name];
            }
          } else {
            this.fields[index].value = this.dataMaskToSave[field1.name];
          }
        }
        this.jsonToSendArxivar.fields.push(this.fields[index]);
      });
      this.fieldName = field.name;
      const dialogRef = this.dialog.open(DialogMaskComponent, {
        width: '80%',
        height: '80%',
        data: {
          json: this.jsonToSendArxivar,
          id: field.insertMaskId,
          fieldName: field.name,
          dataMask: this.dataMaskToSave,
          dataAssociations: this.dataValueAssociations
        }
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result.hasOwnProperty('docNumber')) {

          this.docNumberClasseboxTemp = new Array<string>();
          this.docNumberClasseboxTemp = this.mapClasseBookToSave.get(result.fieldClassName);
          this.docNumberClasseboxTemp.push(result.docNumber);
          this.mapClasseBookToSave.set(result.fieldClassName, this.docNumberClasseboxTemp);

          this.arrayToObject = {};
          this.apiService.getProfileDetailsClass(result.docNumber).subscribe(callResults => {
            callResults.fields.forEach(fieldClass => {
              this.displayedColumnsClass.forEach(colum => {
                if (colum === fieldClass.description) {
                  this.arrayToObject[colum] = fieldClass.value;
                }
              });
            });
            this.ELEMENT_DATA_CLASS.push(this.arrayToObject);
            this.dataSourceClass = new MatTableDataSource(this.ELEMENT_DATA_CLASS);
            console.log(callResults);
          });
        }
      });
    }
  }

  openClassMasks(field: any): void {

    if (!field.locked) {
      this.fieldName = field.name;
      this.apiService.getClassAdditionalFieldsV2(field.name, this.classProfileValue, this.mapClasseBookToSave.get(field.name)).subscribe(callResults => {
        this.apiService.viewDataToShow = callResults;
        const dialogRef = this.dialog.open(DialogClassViewDTOComponentDTOComponent, {
          width: '80%',
          height: '80%',
          data: {
            classField: field,
            mapClassValue: this.mapClasseBookToSave.get(field.name),
            docType: this.classProfileValue
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          // // // // console.log(this.mapClasseBookToSave.get(result.fieldName));
        });
      });


    }
  }

  searchMaskFromClassDTO(field: any): void {
    if (!field.locked) {
      const dialogRef = this.dialog.open(DialogSearchDocComponent, {
        width: '80%',
        height: 'fit-content',
        data: {
          classField: field
        }
      });
      dialogRef.afterClosed().subscribe(res => {
        // // console.log(this.mapClasseBookToSave.get(result.fieldName));
        // // console.log(res);

        res.dataResult.forEach(result => {


          this.docNumberClasseboxTemp = new Array<string>();
          // // console.log(this.mapClasseBookToSave);
          this.docNumberClasseboxTemp = this.mapClasseBookToSave.get(result.fieldName);
          // // console.log(this.docNumberClasseboxTemp);

          this.docNumberClasseboxTemp.push(result.docNumber);
          this.mapClasseBookToSave.set(result.fieldName, this.docNumberClasseboxTemp);

          this.arrayToObject = {};
          this.apiService.getProfileDetailsClass(result.docNumber).subscribe(callResults => {
            callResults.fields.forEach(fieldClass => {
              this.displayedColumnsClass.forEach(colum => {
                if (colum === fieldClass.description) {
                  this.arrayToObject[colum] = fieldClass.value;
                }
              });
            });
            this.ELEMENT_DATA_CLASS.push(this.arrayToObject);
            this.dataSourceClass = new MatTableDataSource(this.ELEMENT_DATA_CLASS);
            // // // // console.log(this.ELEMENT_DATA_CLASS);
          });
        });
      });
    }
  }

  onResize(event): void {
    this.breakpoint = (event.target.innerWidth <= 600) ? 4 : 6;
  }

  showFileSelection(event): void {
    this.fileInfo = {name: '', buffer: ''};
    this.fileListMain = event.target.files;
    if (this.fileListMain.length > 0) {
      this.fileMain = this.fileListMain[0];
      this.formDataMain = new FormData();
      this.formDataMain.append('file', this.fileMain, this.fileMain.name);
      this.apiService.openBuffer(this.formDataMain).subscribe(result => {
        this.fileInfo.name = this.fileMain.name;
        this.fileInfo.buffer = result[0];
        this.bufferIdInfo.push(this.fileInfo);
        this.badgeBufferMain = this.bufferIdInfo.length;
      });
    }
  }

  deleteAttach(bufferId: string): void {
    this.bufferIdInfo2.forEach((res, index) => {
      if (res.buffer === bufferId) {
        this.bufferIdInfo2.splice(index, 1);
        this.snackBar.open('Allegato eliminato con successo', null, {
          duration: 7000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
          panelClass: ['mat-toolbar', 'custom-warning-bg']
        });
      }
    });
  }

  addAttach(event): void {
    this.fileInfo = {name: '', buffer: ''};
    this.fileListMain = event.target.files;
    if (this.fileListMain.length > 0) {
      this.fileMain = this.fileListMain[0];
      this.formDataMain = new FormData();
      this.formDataMain.append('file', this.fileMain, this.fileMain.name);
      this.apiService.openBuffer(this.formDataMain).subscribe(result => {
        this.fileInfo.name = this.fileMain.name;
        this.fileInfo.buffer = result[0];
        this.bufferIdInfo2.push(this.fileInfo);
      });
    }
  }

  showAttachments(): void {
    this.whatToShow = 'attachments';
  }

  showNotes(): void {
    this.whatToShow = 'note';
  }

  showDesk(): void {
    this.whatToShow = 'default';
  }

  removeFile(file: any): void {
    this.apiService.deleteBuffer(file).subscribe(result => {
      if (result) {
        this.snackBar.open('File ' + file.name + ' eliminato!', null, {
          duration: 5000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
          panelClass: ['mat-toolbar', 'custom-success-bg']
        });
        this.bufferIdInfo.forEach((item, index) => {
          if (item.buffer === file.buffer) {
            this.bufferIdInfo.splice(index, 1);
          }
        });
        this.badgeBufferMain = this.bufferIdInfo.length;
      }
    });
  }

  saveMask(): void {
    this.validationCheck = true;
    this.fields.forEach(field => {
      if (field.visible) {
        if (field.required) {
           console.log(this.dataMaskToSave);
          if ((field.value === '' || field.value == null || field.value === '0001-01-01T00:00:00')
            && (this.dataMaskToSave[field.name] === '' || this.dataMaskToSave[field.name] == null)) {
            this.snackBar.open('Il campo ' + field.description + ' è obbligatorio', null, {
              duration: 5000,
              horizontalPosition: 'end',
              verticalPosition: 'bottom',
              panelClass: ['mat-toolbar', 'custom-danger-bg']
            });
            this.validationCheck = false;
          }
        }
      }
    });
    if (this.validationCheck) {

      this.buildDataMask();
    }
  }

  buildDataMask(): void {

    const attach: Array<string> = new Array<string>();
    this.bufferIdInfo2.forEach(res => {
      attach.push(res.buffer);
    });
    if (this.bufferIdInfo.length > 0) {
      this.jsonToSendArxivar = {
        document: {
          fileNames: [],
          bufferIds: []
        },
        fields: [],
        notes: this.notes,
        attachments: attach
      };
      this.bufferIdInfo.forEach(file => {
        this.jsonToSendArxivar.document.fileNames.push(file.name);
        this.jsonToSendArxivar.document.bufferIds.push(file.buffer);
      });
    } else {
      this.jsonToSendArxivar = {
        fields: [],
        notes: this.notes,
        attachments: attach
      };
    }
    this.observable = new Observable(this.myObservableLoading);
    this.showProgressSpinner(this.observable);
    this.fields.forEach((field, index) => {
      if (field.visible) {
        // // // // console.log(this.dataMaskToSave);
        if (field.className === 'AdditionalFieldDateTimeDTO') {
          this.fields[index].value = this.TransformDataFormatToSave(this.dataMaskToSave[field.name]);
        } else if (field.className === 'AdditionalFieldDoubleDTO') {
          if (this.dataMaskToSave[field.name]) {
            this.fields[index].value = (this.dataMaskToSave[field.name].toString().replace(',', '.'));
          } else {
            this.fields[index].value = this.dataMaskToSave[field.name];
          }
        } else {
          this.fields[index].value = this.dataMaskToSave[field.name];
        }


        // // // // // console.log(this.dataMaskToSave[field.name]);

        // // // // // console.log(field);
      }
      this.jsonToSendArxivar.fields.push(this.fields[index]);
    });
    // // console.log(this.jsonToSendArxivar);
    if (this.canProfile) {
      if (this.idTask === '0') {
        this.canProfile = false;
        this.apiService.insertNewProfile(this.jsonToSendArxivar, this.id).subscribe(results => {
          if (results.showMessage) {

            this.savedProfileId = results.docNumber;
            if (false) {
              const checkWFBody = {
                searchFilterDtoList: [
                  {
                    description: 'Ricerca 1',
                    daAAndOr: 0,
                    fields: [

                      {
                        operator: 3,
                        valore1: results.docNumber,
                        valore2: null,
                        groupId: 0,
                        fieldType: 0,
                        additionalFieldType: 0,
                        defaultOperator: 3,
                        tableName: null,
                        binderFieldId: 0,
                        multiple: null,
                        name: 'DocNumber',
                        externalId: '',
                        description: 'System Id:',
                        order: 38,
                        dataSource: '',
                        required: false,
                        formula: '',
                        className: 'FieldBaseForSearchIntDto',
                        locked: false,
                        comboGruppiId: '',
                        dependencyFields: [],
                        associations: null,
                        isAdditional: false,
                        visible: true,
                        predefinedProfileFormula: null,
                        and: null
                      },

                    ]
                  }
                ],
                selectFilterDto: {
                  fields: [
                    {
                      fieldType: 0,
                      selected: true,
                      name: 'WORKFLOW',
                      index: 2,
                      orderBy: {
                        direction: 0,
                        index: 0
                      }
                    },
                    {
                      fieldType: 0,
                      selected: true,
                      name: 'DOCNUMBER',
                      index: 8,
                      orderBy: {
                        direction: 2,
                        index: 0
                      }
                    },
                  ],
                  maxItems: 0
                }
              };
              let repetitions = 0;
              this.sub = setInterval(() => {
                repetitions++;
                this.apiService.doSearch(checkWFBody).subscribe(result => {
                  if (result.data[0][0] === 1) {
                    this.dialogRefSpinner.close();
                    clearInterval(this.sub);
                    this.snackBar.open('Profilo caricato correttamente con id: ' + results.docNumber, null, {
                      duration: 5000,
                      horizontalPosition: 'end',
                      verticalPosition: 'bottom',
                      panelClass: ['mat-toolbar', 'custom-success-bg']
                    });
                    this.goBack();
                  }
                });
                if (repetitions === 20) {
                  clearInterval(this.sub);
                  this.snackBar.open('Attenzione, processo di workflow non avviato nei tempi prestabiliti, contattare l\'assistenza per verificare. Il documento è stato comunque inserito con id:' + +results.docNumber, null, {
                    duration: 5000,
                    horizontalPosition: 'end',
                    verticalPosition: 'bottom',
                    panelClass: ['mat-toolbar', 'custom-danger-bg']
                  });
                  this.dialogRefSpinner.close();
                  this.goBack();
                }
              }, 1000);
            } else {
              this.snackBar.open('Profilo caricato correttamente con id: ' + results.docNumber, null, {
                duration: 5000,
                horizontalPosition: 'end',
                verticalPosition: 'bottom',
                panelClass: ['mat-toolbar', 'custom-success-bg']
              });

              this.apiService.updateProfile(this.tempBodySetRapportinato, this.tempBodySetRapportinato.profileInfo.docNumber).subscribe(profile => {
                this.currentEventAddMask['isRapportinato'] = true;
              });

              this.savedDocN = results.docNumber;
              this.dialogRefSpinner.close();
              this.goBack();
            }
            /*this.observable = new Observable(this.myObservableLoading);
            this.showProgressSpinnerUntilExecuted(this.observable);*/

          } else {
            this.canProfile = true;
            this.snackBar.open('Errore nel caricamento del profilo', null, {
              duration: 5000,
              horizontalPosition: 'end',
              verticalPosition: 'bottom',
              panelClass: ['mat-toolbar', 'custom-danger-bg']
            });
          }
        }, errorLog => {
          this.canProfile = true;
          this.dialogRefSpinner.close();
          this.snackBar.open(errorLog.error.userMessage, null, {
            duration: 7000,
            horizontalPosition: 'end',
            verticalPosition: 'bottom',
            panelClass: ['mat-toolbar', 'custom-danger-bg']
          });
        });
      } else {
        this.canProfile = false;
        this.apiService.insertTaskByMask(this.idTask, this.operationId, this.jsonToSendArxivar).subscribe(results => {
          if (results.showMessage) {
            this.snackBar.open('Profilo caricato correttamente nel task con id: ' + this.idTask, null, {
              duration: 5000,
              horizontalPosition: 'end',
              verticalPosition: 'bottom',
              panelClass: ['mat-toolbar', 'custom-success-bg']
            });
            this.savedDocN = results.docNumber;
            this.dialogRefSpinner.close();
            this.goBack();
          } else {
            this.canProfile = true;
            this.snackBar.open('Errore nel caricamento del profilo', null, {
              duration: 5000,
              horizontalPosition: 'end',
              verticalPosition: 'bottom',
              panelClass: ['mat-toolbar', 'custom-danger-bg']
            });
          }
        }, errorLog => {
          this.dialogRefSpinner.close();
          this.canProfile = true;
          this.snackBar.open(errorLog.error.userMessage, null, {
            duration: 7000,
            horizontalPosition: 'end',
            verticalPosition: 'bottom',
            panelClass: ['mat-toolbar', 'custom-danger-bg']
          });
        });
      }
    }
  }

  TransformDataFormatToSave(Data: string): string {

    if (Data === '' || !Data) {
      return '0001-01-01T00:00:00';
    }
    // // console.log(Data);
    let dateMomentObject = moment(Data, 'DD/MM/YYYY'); // 1st argument - string, 2nd argument - format
    let dateObject = dateMomentObject.toDate();
    // // console.log(dateMomentObject);
    if (dateMomentObject.isValid()) {
      return this.datePipe.transform(dateObject, 'yyyy-MM-dd', '', 'en-GB');
    } else {
      return this.datePipe.transform(Data, 'yyyy-MM-dd', '', 'en-GB');
    }

  }

  TransformDataFormatToShow(Data: string): string {
    return this.datePipe.transform(Data, 'dd/MM/yyyy', '', 'en-GB');
  }

  TransformData(Data: string): string {
    Data = Data.replace(' 00:00:00', '');
    return this.datePipe.transform(Data, 'dd/MM/yyyy', '', 'en-US');
  }

  getAllNullProfileValue(): void {
    this.fields.forEach((val, index) => {
      if (this.comboValues[val.name]) {
        // console.log(this.comboValues[val.name]);
        if (this.comboValues[val.name].length === 1) {
          if (val.className === 'AdditionalFieldComboDTO') {
            this.apiService.getProfileValuesWithFilter(val.name, this.getJsonFields().fields).subscribe(results => {
              // console.log(results);
              this.tempCombo = new Array<any>();
              results.dataSource.forEach(res => {
                this.selectToAdd = '';
                this.keyToAdd = '';
                res.columns.forEach(r => {
                  if (results.selectField.toLowerCase().includes(r.id.toLowerCase())) {
                    this.selectToAdd += r.value + ' - ';
                  }
                  if (results.keyField.toLowerCase().includes(r.id.toLowerCase())) {
                    this.keyToAdd += r.value + ' - ';
                  }
                });
                this.tempCombo.push({
                  selectField: this.selectToAdd.substr(0, this.selectToAdd.length - 3),
                  keyField: this.keyToAdd.substr(0, this.keyToAdd.length - 3),
                  visible: true
                });
                this.comboValues[val.name] = this.tempCombo;
                if (results.dataSource.length === 1 && !this.dataMaskToSave[val.name]) {
                  /*this.dataMaskToSave[val.name] = this.keyToAdd.substr(0, this.keyToAdd.length - 3);
                  this.checkComboAssociations(val);*/
                }
              });
            });
          } else {
            if (val.className === 'AdditionalFieldTableDTO' || val.className === 'AdditionalFieldMultivalueDTO') {
              this.apiService.getProfileValuesWithFilter(val.name, this.getJsonFields().fields).subscribe(results => {
                this.tableAssociationField = {};
                this.tableAssociationField = Object.keys(results.associations)
                  .reduce((c, k) => (c[k.toLowerCase()] = results.associations[k], c), {});
                // console.log(this.tableAssociationField);
                if (results.dataSource.length === 0) {
                  this.fields.forEach((item, subindex) => {

                    if ((item.name === val.name) && (item.limitToList === true)) {
                      this.fields[subindex].value = '';
                      this.dataMaskToSave[this.fields[subindex].name] = '';
                    }
                  });
                }
              });
            }
          }
        }
      } else {
        if (!val.value && !this.comboControl[val.name]) {
          if (val.className === 'AdditionalFieldComboDTO') {
            this.apiService.getProfileValuesWithFilter(val.name, this.getJsonFields().fields).subscribe(results => {
              // console.log(results);
              this.tempCombo = new Array<any>();
              if (results.dataSource) {
                results.dataSource.forEach(res => {
                  this.selectToAdd = '';
                  this.keyToAdd = '';
                  res.columns.forEach(r => {
                    if (results.selectField.toLowerCase().includes(r.id.toLowerCase())) {
                      this.selectToAdd += r.value + ' - ';
                    }
                    if (results.keyField.toLowerCase().includes(r.id.toLowerCase())) {
                      this.keyToAdd += r.value + ' - ';
                    }
                  });
                  this.tempCombo.push({
                    selectField: this.selectToAdd.substr(0, this.selectToAdd.length - 3),
                    keyField: this.keyToAdd.substr(0, this.keyToAdd.length - 3),
                    visible: true
                  });
                  this.comboValues[val.name] = this.tempCombo;
                  if (results.dataSource.length === 1 && !this.dataMaskToSave[val.name]) {
                    this.dataMaskToSave[val.name] = this.keyToAdd.substr(0, this.keyToAdd.length - 3);
                    this.checkComboAssociations(val);
                  }
                });
              }
            });
          } else {
            if (val.className === 'AdditionalFieldTableDTO' || val.className === 'AdditionalFieldMultivalueDTO') {
              this.apiService.getProfileValuesWithFilter(val.name, this.getJsonFields().fields).subscribe(results => {
                this.tableAssociationField = {};
                this.tableAssociationField = Object.keys(results.associations)
                  .reduce((c, k) => (c[k.toLowerCase()] = results.associations[k], c), {});
                // console.log(this.tableAssociationField);
                if (results.dataSource.length === 0) {
                  this.fields.forEach((item, subindex) => {
                    if (this.tableAssociationField.hasOwnProperty(item.name.toLowerCase()) && (item.limitToList === true)) {
                      this.fields[subindex].value = '';
                      this.dataMaskToSave[this.fields[subindex].name] = '';
                    }
                    if ((item.name === val.name) && (item.limitToList === true)) {
                      this.fields[subindex].value = '';
                      this.dataMaskToSave[this.fields[subindex].name] = '';
                    }
                  });
                }
              });
            }
          }
        }
      }

    });
  }

  getAllProfileValue(): void {
    this.fields.forEach((val, index) => {
      if (val.className === 'AdditionalFieldComboDTO' && (this.tempSkipProfileValue !== val.name || !this.tempSkipProfileValue)) {
        this.apiService.getProfileValuesWithFilter(val.name, this.getJsonFields().fields).subscribe(results => {
          this.tempSkipProfileValue = null;
          // // console.log(results);
          this.tempCombo = new Array<any>();
          if (results.dataSource) {
            results.dataSource.forEach(res => {
              this.selectToAdd = '';
              this.keyToAdd = '';
              res.columns.forEach(r => {
                if (results.selectField.toLowerCase().includes(r.id.toLowerCase())) {
                  this.selectToAdd += r.value + ' - ';
                }
                if (results.keyField.toLowerCase().includes(r.id.toLowerCase())) {
                  this.keyToAdd += r.value + ' - ';
                }
              });
              this.tempCombo.push({
                selectField: this.selectToAdd.substr(0, this.selectToAdd.length - 3),
                keyField: this.keyToAdd.substr(0, this.keyToAdd.length - 3),
                visible: true
              });
              this.comboValues[val.name] = this.tempCombo;
            });
          }
        });
      } else {
        if (val.className === 'AdditionalFieldTableDTO' || val.className === 'AdditionalFieldMultivalueDTO') {
          this.apiService.getProfileValuesWithFilter(val.name, this.getJsonFields().fields).subscribe(results => {
            this.tableAssociationField = {};
            this.tableAssociationField = Object.keys(results.associations)
              .reduce((c, k) => (c[k.toLowerCase()] = results.associations[k], c), {});
            // console.log(this.tableAssociationField);
            if (results.dataSource.length === 0) {
              this.fields.forEach((item, subindex) => {
                if (this.tableAssociationField.hasOwnProperty(item.name.toLowerCase()) && (item.limitToList === true)) {
                  this.fields[subindex].value = '';
                  this.dataMaskToSave[this.fields[subindex].name] = '';
                }
                if ((item.name === val.name) && (item.limitToList === true)) {
                  this.fields[subindex].value = '';
                  this.dataMaskToSave[this.fields[subindex].name] = '';
                }
              });
            }
          });
        }
      }

    });
    this.checkFormula();

  }

  getJsonFields(): any {
    if (this.bufferIdInfo.length > 0) {
      this.jsonToSendArxivar = {
        document: {
          fileNames: [],
          bufferIds: []
        },
        fields: []
      };
      this.bufferIdInfo.forEach(file => {
        this.jsonToSendArxivar.document.fileNames.push(file.name);
        this.jsonToSendArxivar.document.bufferIds.push(file.buffer);
      });
    } else {
      this.jsonToSendArxivar = {
        fields: []
      };
    }
    // // // // // console.log(this.dataMaskToSave);
    this.fields.forEach((field, index) => {
      if (field.visible || this.dataMaskToSave[field.name]) {
        // // // // console.log(this.dataMaskToSave);
        if (field.className === 'AdditionalFieldDateTimeDTO') {
          this.fields[index].value = this.TransformDataFormatToSave(this.dataMaskToSave[field.name]);
        } else if (field.className === 'AdditionalFieldDoubleDTO') {
          if (this.dataMaskToSave[field.name]) {
            this.fields[index].value = (this.dataMaskToSave[field.name].toString().replace(',', '.'));
          } else {
            this.fields[index].value = this.dataMaskToSave[field.name];
          }
        } else {
          this.fields[index].value = this.dataMaskToSave[field.name];
        }


        // // // // // console.log(this.dataMaskToSave[field.name]);

        // // // // // console.log(field);
      }
      this.jsonToSendArxivar.fields.push(this.fields[index]);
    });
    return this.jsonToSendArxivar;
  }

  goBack(): void {
    this.isNewRapportino = false;
  }
}

